module.exports    = {
	"language": "Language",
	"hello": "Hello {{.a}}",
	"c001": "Service timeout. Please try again later!",
	"c002": "Exit",
	"c003": "Log In",
	"c004": "Enter user name",
	"c005": "Enter login password",
	"c006": "Save",
	"c007": "The account name or password is incorrect.",
	"c008": "Account",
	"c009": "Language",
	"c010": "Total",
	"c011": "records",
	"c012": "Hello,",
	"c013": "Your account has not been activated. Contact the administrator.",
	"c014": "Your account has been locked. Contact the administrator.",
	"c015": "Reset",
	"c016": "WebSocket connection failed.",
	"c017": "Internal error",
	"c018": "You do not have permission to perform this operation.",
	"c019": "The current user is not authorized to view this page.",
	"c020": "Your login session has expired. Log in again!",
	"c021": "User Login",
	"c022": "Documentation",
	"c023": "Conforming",
	"c024": "Nonconforming",
	"c025": "Result",
	"c026": "System",
	"c027": "Database connection error. Check the database connection.",
	"c028": "Database initialization error. Check the database.",
	"m001": "Offline",
	"m002": "Online",
	"m003": "Abnormal",
	"m004": "Deleted",
	"m005": "Add Machine",
	"m006": "Edit Machine",
	"m007": "Machine Management",
	"m008": "No.",
	"m009": "Status",
	"m010": "Machine ID",
	"m011": "Machine Name",
	"m012": "Assigned Area",
	"m013": "Sort Order",
	"m014": "IP Address",
	"m015": "Communication Address",
	"m016": "Remarks",
	"m017": "Updated At",
	"m018": "Actions",
	"m019": "Edit",
	"m020": "Machine updated successfully.",
	"m021": "Machine added successfully.",
	"m022": "Duplicate machine name, machine ID, or IP address.",
	"m023": "The machine name is required and must contain at least 2 characters.",
	"m024": "The machine ID is required and must contain at least 2 characters.",
	"m025": "The IP address is required.",
	"m026": "The port must be an integer with no more than 5 digits.",
	"m027": "Delete",
	"m028": "Restore",
	"m029": "Port",
	"m030": "Enable Automatic Connection",
	"m031": "Note: The communication address must match the address configured in the welding controller programmer.",
	"m032": "All Areas",
	"m033": "All Statuses",
	"m034": "Select",
	"m035": "Online",
	"m036": "Offline",
	"m037": "An error occurred while deleting the machine. Please try again later.",
	"m038": "An error occurred while restoring the machine. Please try again later.",
	"m039": "Machine deleted successfully.",
	"m040": "Machine restored successfully.",
	"m041": "An error occurred while retrieving machine data. Please try again later.",
	"m042": "Invalid IP address format.",
	"m043": "The communication address must be an integer with no more than 5 digits.",
	"m044": "Select an area.",
	"m045": "Failed to update the machine.",
	"m046": "Failed to add the machine.",
	"m047": "The machine name already exists. Enter a different name.",
	"m048": "The machine ID already exists. Enter a different ID.",
	"m049": "The IP address already exists. Enter a different address.",
	"m050": "Acquire Current Curve",
	"m051": "Acquire Voltage Curve",
	"m052": "Acquire Resistance Curve",
	"m053": "Acquire Force Curve",
	"m054": "Automatic Connection",
	"m055": "Error parsing the import file.",
	"m056": "Error reading the uploaded file.",
	"m057": "Invalid file extension (.xlsx, .xlsm, or .xltx required).",
	"m058": "The file is too large (maximum 10 MB).",
	"m059": "Machine",
	"m060": "Field",
	"m061": "Import completed: {{.a}} records imported, including {{.b}} new or updated records.",
	"m062": "Import failed.",
	"m063": "Close",
	"m064": "The same weld schedule cannot be compared with itself.",
	"m065": "Error querying the controller list.",
	"m066": "This file extension is not allowed.",
	"m067": "Incorrect password. Enter it again.",
	"m068": "Upgrade completed successfully.",
	"m069": "Restore the controller to factory settings?",
	"m070": "Only machine type 803 is supported.",
	"m071": "The system is processing the request. Please wait.",
	"m072": "Task added successfully and is being processed.",
	"m073": "Importing will overwrite the existing data. Continue?",
	"m074": "File write error.",
	"m075": "Search machine name / machine ID / IP address / remarks / MAC address",
	"m076": "Connect All",
	"m077": "Disconnect All",
	"m078": "All machines connected successfully.",
	"m079": "All machines disconnected successfully.",
	"m080": "Failed to connect all machines.",
	"m081": "Failed to disconnect all machines.",
	"m082": "Unable to create the Excel workbook.",
	"m083": "Weld curve deserialization error.",
	"m084": "Error retrieving alarm records.",
	"m085": "Error writing System Parameter Set 1.",
	"m086": "Error writing System Parameter Set 2.",
	"m087": "Error writing System Parameter Set 3.",
	"m088": "Not found. Add the corresponding area first.",
	"m089": "Total Machines",
	"m090": "Reconnect",
	"m091": "Back Up",
	"m092": "Weld Schedule Parameters",
	"m093": "System Parameters",
	"m094": "No machines are selected!",
	"m095": "No parameters are selected for backup!",
	"m096": "Batch backup is in progress. Please wait.",
	"m097": "The backup does not exist!",
	"m098": "Error packaging the backup!",
	"m099": "Batch backup completed. Download the backup package.",
	"m100": "Failed to create the TAR archive.",
	"m101": "Failed to obtain the path.",
	"m102": "Backup completed successfully.",
	"m103": "Select the upgrade file.",
	"m104": "Machine Upgrade",
	"m105": "An error occurred during the upgrade.",
	"m106": "The firmware data is empty. The upgrade cannot be performed.",
	"m107": "Cannot connect to machine “{{.a}}”. Check the connection. If the problem persists, restart the machine.",
	"m108": "The selected file is not a valid upgrade package.",
	"m109": "Failed to send the start packet.",
	"m110": "Invalid response to the start packet.",
	"m111": "Error sending data packet at packet position “{{.a}}”.",
	"m112": "Error receiving data packet at packet position “{{.a}}”.",
	"m113": "Error sending the end packet.",
	"m114": "Error receiving the end-packet response.",
	"m115": "The machine is being upgraded. Please wait.",
	"m116": "Machine upgrade in progress",
	"m117": "Machine upgrade completed successfully.",
	"m118": "Machine upgrade failed.",
	"m119": "Retry",
	"m120": "Waiting to Start",
	"m121": "Upgrade Progress Overview",
	"m122": "Successful:",
	"m123": "Failed",
	"m124": "In Progress",
	"m125": "Machine Upgrade Details",
	"m126": "The firmware file was lost when the page was refreshed, so the upgrade cannot be retried.",
	"m127": "Other",
	"m128": "Upgrade canceled.",
	"m129": "Canceling...",
	"m130": "Canceling the upgrade will stop upgrading all remaining machines. Continue?",
	"m131": "Online Machines",
	"m132": "Offline Machines",
	"m133": "Reconnect Machines",
	"m134": "Machine Name / Machine ID / IP",
	"m135": "No matching machines were found.",
	"m136": "No machines are currently available for this operation.",
	"m137": "Machine ID",
	"m138": "Original Controller Software Version",
	"m139": "Download failed. No matching data was found.",
	"m140": "Operation Result",
	"m141": "Machine Type",
	"m142": "Select a machine type.",
	"m143": "This machine type is not activated for your software version. Contact the manufacturer to activate it.",
	"m144": "HRC-803 Medium-Frequency Welding Machine",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650 Weld Quality Monitor",
	"m149": "HRC-670 Riveting Quality Monitor",
	"m150": "HRC-62 AC Welding Machine",
	"m151": "Current Activation Code",
	"m152": "Parameter Backup",
	"m153": "Parameter Restore",
	"m154": "Import Machines",
	"m155": "Export All Machines",
	"m156": "Machine parameter backup is in progress. Please wait.",
	"m157": "Parameter backup canceled.",
	"m158": "Unable to create the backup directory. Parameter backup failed.",
	"m159": "An error occurred during backup. Parameter backup failed.",
	"m160": "Unable to read weld schedule data. Parameter backup failed.",
	"m161": "Unable to create the Excel workbook. Parameter backup failed.",
	"m162": "Unable to read system parameters. Parameter backup failed.",
	"m163": "The machine is offline. Parameter backup failed.",
	"m164": "Parameter Backup Progress Overview",
	"m165": "Parameter Backup Details",
	"m166": "Backing Up Machine Parameters",
	"m167": "Parameter backup completed successfully.",
	"m168": "Parameter backup failed.",
	"m169": "Back Up Weld Schedule Parameters",
	"m170": "Weld Schedule Parameter Backup Progress",
	"m171": "System Parameter Backup Progress",
	"m172": "Weld Spot Information Backup Progress",
	"m173": "The retry upgrade task has started.",
	"m174": "The retry backup task has started.",
	"m175": "The cancel-upgrade task has started.",
	"m176": "The cancel-backup task has started.",
	"m177": "Canceling the backup will stop backing up all remaining machines. Continue?",
	"m178": "Select a TAR archive.",
	"m179": "Error extracting the archive. Check that the file is valid.",
	"m180": "Parameter restore completed.",
	"m181": "An error occurred during parameter restore.",
	"m182": "Parameter Restore Progress Overview",
	"m183": "Parameter Restore Details",
	"m184": "Restoring Machine Parameters",
	"m185": "Parameter restore completed successfully.",
	"m186": "Parameter restore failed.",
	"m187": "Weld Schedule Parameter Restore Progress",
	"m188": "System Parameter Restore Progress",
	"m189": "Weld Spot Information Restore Progress",
	"m190": "Error importing weld spot information.",
	"m191": "Backup canceled.",
	"m192": "Parameter restore canceled.",
	"m193": "A backup or restore task is running on the machine. Download is unavailable.",
	"m194": "Canceling parameter restore will stop restoring all remaining machines. Continue?",
	"m195": "The corresponding machine was not found in the archive. Check the file.",
	"m196": "The retry parameter-restore task has started.",
	"m197": "Another task is running on the machine. This operation is unavailable.",
	"m198": "Parameters to Restore:",
	"m199": "No machine type is activated by your activation information, so machines cannot currently be added or modified.",
	"m200": "This operation is not currently supported for this machine.",
	"m201": "Backup File",
	"m202": "The import file does not match the machine ID or type. The filename prefix must be: machine ID + {{.a}}",
	"m203": "Login Password",
	"m204": "Select a file.",
	"m205": "Cleared data cannot be recovered. Clear the data?",
	"m206": "Clear Backups",
	"m207": "Clear",
	"m208": "Cleared successfully.",
	"m209": "Failed to clear.",
	"m210": "Duplicate machine MAC address.",
	"m211": "User “{{.a}}” backed up the parameters of machine “{{.b}}”:",
	"m212": "The current machine is already open. Duplicate operation is not allowed.",
	"m213": "MAC Address",
	"m214": "Expulsion Point",
	"m215": "Help",
	"m216": "Disconnect Area",
	"m217": "Connect Area",
	"p001": "Create Area",
	"p002": "Edit Area",
	"p003": "The area is referenced and cannot be deleted.",
	"p004": "Area Management",
	"p005": "Area Name",
	"p006": "Area Remarks",
	"p007": "Area updated successfully.",
	"p008": "Area added successfully.",
	"p009": "Duplicate area name.",
	"p010": "The area name is required and must contain at least 2 characters.",
	"p011": "The sort order must be a positive integer with no more than 5 digits.",
	"p012": "Invalid pagination parameters.",
	"p013": "An error occurred while retrieving area data. Please try again later.",
	"p014": "The input ID is invalid and must be an integer.",
	"p015": "Error submitting data.",
	"p016": "The area name already exists. Change it and submit again.",
	"p017": "An error occurred while adding the area. Please try again later.",
	"p018": "An error occurred while updating the area. Please try again later.",
	"p019": "An error occurred while checking whether the area is in use. Please try again later.",
	"p020": "An error occurred while deleting the area. Please try again later.",
	"p021": "An error occurred while restoring the area. Please try again later.",
	"p022": "Area deleted successfully.",
	"p023": "Area restored successfully.",
	"p024": "records/page",
	"p025": "Weld Schedule No. Before Tip Dressing",
	"p026": "Weld Schedule No. After Tip Dressing",
	"p027": "No data available.",
	"p028": "Save Reference Curve",
	"p029": "This record does not contain resistance-curve data.",
	"p030": "Query Resistance Curves Before and After Tip Dressing",
	"p031": "The curve data lengths before and after tip dressing do not match. Selection is unavailable.",
	"p032": "This record does not contain a resistance curve.",
	"p033": "The selected curve length does not match the current chart length. Selection is unavailable.",
	"p034": "Before Tip Dressing",
	"p035": "After Tip Dressing",
	"p036": "Select a curve record first.",
	"p037": "The selected record does not contain resistance-curve data.",
	"p038": "[Reference Curve] Before Tip Dressing",
	"p039": "[Reference Curve] After Tip Dressing",
	"p040": "Generate a reference curve first.",
	"p041": "Reference curve saved successfully.",
	"p042": "Error querying reference-curve records.",
	"p043": "Invalid curve data.",
	"p044": "The curve is outside the fluctuation range allowed for the saved reference curve and cannot be generated.",
	"p045": "The real-time curve and reference curve have different lengths.",
	"p046": "The real-time post-dressing curve is outside the tolerance range.",
	"p047": "Tip-Dressing Settings",
	"p048": "View Tip-Dressing Settings",
	"p049": "Manage Tip-Dressing Settings",
	"p050": "Tip-Dressing Monitoring",
	"p051": "View Tip-Dressing Monitoring",
	"p052": "Manage Tip-Dressing Monitoring",
	"p053": "Reference-Curve Fluctuation Range for Saving",
	"p054": "Reference-Curve Fluctuation Range for Monitoring",
	"p055": "Alarm Type",
	"p056": "View",
	"p057": "[Real-Time Curve] Before Tip Dressing",
	"p058": "[Real-Time Curve] After Tip Dressing",
	"p059": "Current Reference Resistance Curve",
	"p060": "Reference Resistance Curve",
	"p061": "Preview Resistance Curve",
	"p062": "The resistance after tip dressing is greater than the resistance before tip dressing.",
	"p063": "The upper and lower tolerances for automatic rejection must be greater than 0.",
	"p064": "Automatic-Rejection Upper and Lower Tolerances",
	"p065": "Weld-Resistance Curve Monitoring Settings",
	"p066": "Enable Pre-Filtering",
	"p067": "Average resistance before tip dressing minus average resistance after tip dressing is greater than",
	"p068": "Classify as Normal",
	"p069": "The system automatically removed curves outside the tolerance range.",
	"p070": "Post-Dressing Curve Upper Tolerance",
	"p071": "Post-Dressing Curve Lower Tolerance",
	"p072": "Enter the weld schedule numbers before and after tip dressing.",
	"p073": "Resistance before tip dressing minus resistance after tip dressing must be greater than 0.",
	"p074": "The upper and lower tolerances for the post-dressing curve must be greater than 0.",
	"p075": "Pre-filter result is outside the normal range.",
	"p076": "Software Version",
	"p077": "This feature is not supported by the current version.",
	"p078": "Primary-current calibration is set to System Default and cannot be calibrated.",
	"p079": "Stage",
	"p080": "Lower Limit",
	"p081": "Upper Limit",
	"p082": "The ending weld schedule number cannot be less than the starting weld schedule number.",
	"p083": "The weld schedule number ranges do not match. The operation cannot be performed.",
	"p084": "Synchronize Weld Schedules",
	"p085": "differences",
	"p086": "All Identical",
	"p087": "The source and target machines are the same. Synchronization is unavailable.",
	"p088": "] weld schedule parameters to the target machine:",
	"p089": "Parameter Synchronization",
	"p090": "Current Coefficient",
	"p091": "Maximum Secondary Output Current",
	"p092": "Current Power-Factor Angle",
	"p093": "Current Trigger-Control Angle",
	"p094": "Search Criteria",
	"p095": "Keyword",
	"p096": "Acquisition Time Point",
	"u001": "User Management",
	"u002": "Create User",
	"u003": "Name",
	"u004": "Role",
	"u005": "Password",
	"u006": "Edit User",
	"u007": "Viewer",
	"u008": "Operator",
	"u009": "Administrator",
	"u010": "Not Activated",
	"u011": "Active",
	"u012": "Locked",
	"u013": "The account name must contain at least 3 characters.",
	"u014": "The name must contain at least 3 characters.",
	"u015": "The password must contain at least 3 characters.",
	"u016": "Select a role.",
	"u017": "Select a status.",
	"u018": "User updated successfully.",
	"u019": "User added successfully.",
	"u020": "An error occurred while retrieving user data. Please try again later.",
	"u021": "User deleted successfully.",
	"u022": "User restored successfully.",
	"u023": "The account name already exists. Enter a different name.",
	"u024": "An error occurred while adding the user. Please try again later.",
	"u025": "An error occurred while updating the user. Please try again later.",
	"u026": "An error occurred while deleting the user. Please try again later.",
	"u027": "An error occurred while restoring the user. Please try again later.",
	"u028": "Operator ID",
	"u029": "Role Management",
	"u030": "Create Role",
	"u031": "An error occurred while retrieving role data. Please try again later.",
	"u032": "The role name already exists. Enter a different name.",
	"u033": "An error occurred while adding the role. Please try again later.",
	"u034": "An error occurred while updating the role. Please try again later.",
	"u035": "An error occurred while deleting the role. Please try again later.",
	"u036": "An error occurred while restoring the role. Please try again later.",
	"u037": "Role added successfully.",
	"u038": "Role updated successfully.",
	"u039": "Role deleted successfully.",
	"u040": "Role restored successfully.",
	"u041": "Role Name",
	"u042": "Edit Role",
	"u043": "The role name is required and must contain at least 2 characters.",
	"u044": "Permissions",
	"u045": "Area",
	"u046": "View Areas",
	"u047": "Permission Settings",
	"u048": "Machines",
	"u049": "View Machines",
	"u050": "Connect/Disconnect Machines",
	"u051": "Users",
	"u052": "View Users",
	"u053": "View Weld Schedule Library",
	"u054": "Manage Weld Schedule Library",
	"u055": "View System Logs",
	"u056": "Manage System Logs",
	"u057": "View System Initialization",
	"u058": "Manage System Initialization",
	"u059": "View Real-Time Monitoring",
	"u060": "Operate Real-Time Monitoring",
	"u061": "View Real-Time Monitoring",
	"u062": "Operate Real-Time Monitoring",
	"u063": "View Weld Schedule Parameters",
	"u064": "Edit Weld Schedule Parameters",
	"u065": "View Production Management",
	"u066": "Operate Production Management",
	"u067": "View System Parameters",
	"u068": "Edit System Parameters",
	"u069": "View Weld Records",
	"u070": "Manage Weld Records",
	"u071": "View Alarm Records",
	"u072": "Manage Alarm Records",
	"u073": "View Change Records",
	"u074": "Manage Change Records",
	"u075": "View Weld Spot Management",
	"u076": "Operate Weld Spot Management",
	"u077": "View Roles",
	"u078": "Permissions set successfully.",
	"u079": "Confirm Password",
	"u080": "The passwords do not match. Enter them again!",
	"u081": "You are not authorized to retrieve the registration information. Obtain authorization first.",
	"u082": "Registration information is missing. Activate the product first.",
	"u083": "Invalid registration information. Register the product again.",
	"u084": "This is a trial version. Request an activation code to use the software.",
	"u085": "Activate",
	"u086": "Product Activation",
	"u087": "Product Serial Number",
	"u088": "Send the product serial number below or the QR code on the left to the manufacturer to obtain an activation code.",
	"u089": "Enter Activation Code",
	"u090": "Contact technical support if you have any questions.",
	"u091": "Copied successfully.",
	"u092": "Copy failed.",
	"u093": "Activate Product",
	"u094": "View Activation",
	"u095": "Perform Activation",
	"u096": "Error activating the machine type.",
	"u097": "Failed to generate the activation code.",
	"u098": "The activation code is incorrect.",
	"u099": "Enter the activation code.",
	"u100": "The product serial number is missing.",
	"u102": "The activation code is invalid!",
	"u103": "Failed to write activation information. Please try again later.",
	"u104": "Activation successful. The relevant permissions will be enabled according to your activation code. Contact the manufacturer if you have any questions.",
	"u105": "Change Password",
	"u106": "Current Password",
	"u107": "New Password",
	"u108": "Enter the current password.",
	"u109": "The current password is incorrect.",
	"u110": "Enter the new password.",
	"u111": "Password changed successfully.",
	"u112": "Failed to change the password.",
	"u113": "Displayed Columns",
	"u114": "Select columns to display.",
	"u115": "Select at least one column to display.",
	"l001": "Console",
	"l002": "Connect",
	"l003": "Connect All",
	"l004": "Disconnect All",
	"l005": "Alarm",
	"l006": "Disconnected successfully.",
	"l007": "Connected successfully.",
	"l008": "Disconnection failed.",
	"l009": "Connection failed.",
	"l010": "Collapse All",
	"l011": "Expand All",
	"b001": "Database Management",
	"b002": "Weld Schedule Library",
	"b003": "Copy System Parameters",
	"b004": "Parameter Comparison",
	"b005": "Current Limit Parameters",
	"b006": "Weld Schedule No.",
	"b007": "Weld Schedule Name",
	"b008": "Weld 1 Minimum",
	"b009": "Weld 1 Maximum",
	"b010": "Weld 2 Minimum",
	"b011": "Weld 2 Maximum",
	"b012": "Weld 3 Minimum",
	"b013": "Weld 3 Maximum",
	"b014": "Power-Control Mode",
	"b015": "Hybrid",
	"b016": "Constant Current",
	"b017": "Duty Cycle",
	"b018": "Pre-Squeeze",
	"b019": "Squeeze",
	"b020": "Pre-Weld",
	"b021": "Cool 0",
	"b022": "Upslope",
	"b023": "Weld 1",
	"b024": "Cool 1",
	"b025": "Weld 2",
	"b026": "Cool 2",
	"b027": "Weld 3",
	"b028": "Downslope",
	"b029": "Cool 3",
	"b030": "Post-Weld",
	"b031": "Hold",
	"b032": "Off Time",
	"b033": "Copy",
	"b034": "Clear This Group",
	"b035": "Download This Weld Schedule Group",
	"b036": "Batch Download Weld Schedules",
	"b037": "Weld 2 Pulse Count",
	"b038": "No configuration data.",
	"b039": "Error retrieving the maximum weld schedule value.",
	"b040": "Weld Schedule",
	"b041": "An error occurred while adding the weld schedule. Please try again later.",
	"b042": "Weld schedule added successfully.",
	"b043": "An error occurred while updating the weld schedule. Please try again later.",
	"b044": "Weld schedule updated successfully.",
	"b045": "An error occurred while deleting the weld schedule. Please try again later.",
	"b046": "Weld schedule deleted successfully.",
	"b047": "The weld schedule number already exists. Change it and submit again.",
	"b048": "An error occurred while retrieving the weld schedule number. Please try again later.",
	"b049": "The weld schedule name is required.",
	"b050": "An error occurred while copying the weld schedule. Please try again later.",
	"b051": "Weld schedule copied successfully.",
	"b052": "Select the weld schedule to delete.",
	"b053": "Select the weld schedule to clear.",
	"b054": "Select the weld schedule to copy.",
	"b055": "Deleted data cannot be recovered. Delete the data?",
	"b056": "Select All",
	"b057": "Source Machine",
	"b058": "Target Machine",
	"b059": "Download All System Parameters",
	"b060": "Compare",
	"b061": "Comparison Method",
	"b062": "Controller",
	"b063": "Error querying weld schedule library data.",
	"b064": "Operation error.",
	"b065": "Parameter",
	"b066": "Weld 1 Minimum Current",
	"b067": "Weld 1 Maximum Current",
	"b068": "Weld 2 Minimum Current",
	"b069": "Weld 2 Maximum Current",
	"b070": "Weld 3 Minimum Current",
	"b071": "Weld 3 Maximum Current",
	"b072": "Pre-Squeeze Time",
	"b073": "Pre-Squeeze Air-Pressure Setpoint",
	"b074": "Follow-Up Time",
	"b075": "Follow-Up Air-Pressure Setpoint",
	"b076": "Pre-Weld Control Selection",
	"b077": "Pre-Weld Current",
	"b078": "Pre-Weld Time",
	"b079": "[Reserved] Pre-Weld Force [kN (0–10000) or % (0–100)]",
	"b080": "Cooling Time 0",
	"b081": "[Reserved] Cooling Force 0 (kN or %)",
	"b082": "Upslope Time",
	"b083": "Weld 1 Control Selection",
	"b084": "Weld 1 Current",
	"b085": "Weld 1 Time",
	"b086": "UIP Function Selection (0–1)",
	"b087": "Cooling Time 1",
	"b088": "[Reserved] Weld 1 Force [kN (0–10000) or % (0–100)]",
	"b089": "Weld 2 Control Selection",
	"b090": "Weld 2 Current",
	"b091": "Weld 2 Time",
	"b092": "Weld 2 Force",
	"b093": "Cooling Time 2",
	"b094": "UIP Reference Value (%)",
	"b095": "Weld 2 Pulse Count",
	"b096": "Weld 3 Control Selection",
	"b097": "Weld 3 Current",
	"b098": "Weld 3 Time",
	"b099": "UIP Upper Tolerance Band (%)",
	"b100": "Downslope Time",
	"b101": "Cooling Time 3",
	"b102": "UIP Upper Conditional Tolerance Band",
	"b103": "Post-Weld Control Selection",
	"b104": "Post-Weld Current",
	"b105": "Post-Weld Time",
	"b106": "UIP Lower Conditional Tolerance Band",
	"b107": "Post-Weld Hold Time",
	"b108": "UIP Lower Tolerance Band",
	"b109": "Off Time",
	"b110": "Off-Time Force",
	"b111": "Power-Control Selection (0–2): 0 = Constant Current, 1 = Duty Cycle, 2 = Hybrid",
	"b112": "Expulsion-Detection Resistance Threshold",
	"b113": "Controller 1",
	"b114": "Controller 2",
	"b115": "Weld Schedule Library 1",
	"b116": "Weld Schedule Library 2",
	"b117": "Download This Weld Schedule Group",
	"b118": "Batch Download Weld Schedules",
	"b119": "Select Machine No.:",
	"b120": "Download to controller position:",
	"b121": "Group",
	"b122": "Controller",
	"b123": "From",
	"b124": "To",
	"b125": "Downloaded successfully.",
	"b126": "Error retrieving the machine type.",
	"b127": "The target-machine weld schedule number is outside the range (0–{{.a}}).",
	"b128": "Weld schedule No. “{{.a}}” does not exist.",
	"b129": "Download failed.",
	"b130": "Invalid range selection.",
	"b131": "The download ranges do not match ({{.a}}–{{.b}}).",
	"b132": "User “{{.a}}” downloaded weld schedule No. “{{.c}}” to machine {{.b}}.",
	"b133": "User “{{.a}}” batch-downloaded weld schedules {{.c}}–{{.d}} to positions {{.e}}–{{.f}} on machine {{.b}}.",
	"b134": "Select a source machine and a target machine.",
	"b135": "Confirm Operation",
	"b136": "Synchronize machine [",
	"b137": "Synchronize machine [",
	"b138": "] system parameters to the target machine?",
	"b139": "The submitted data is not a valid controller number.",
	"b140": "User “{{.a}}” copied system parameters from machine ID “{{.b}}” to “{{.c}}”.",
	"b141": "The weld schedule numbers are identical and cannot be compared.",
	"b142": "The weld schedule number is outside the range (0–959).",
	"b143": "The weld schedule number is outside the range (0–63).",
	"b144": "Controller not found.",
	"b145": "[Reserved] Weld 1 Force [kN (0–10000) or % (0–100)]",
	"b146": "[Reserved] Cooling Force 2 [kN (0–10000) or % (0–100)]",
	"b147": "[Reserved] Cooling Force 3 [kN (0–10000) or % (0–100)]",
	"b148": "[Reserved] Post-Weld Force [kN (0–10000) or % (0–100)]",
	"b149": "[Reserved] Hold Force [kN (0–10000) or % (0–100)]",
	"b150": "The same weld schedule cannot be compared with itself.",
	"b151": "Invalid input for {{.a}}.",
	"b152": "Input validation error.",
	"b153": "Synchronize from Machine to Offline Library",
	"b154": "Synchronize from Offline Library to Machine",
	"b155": "No.",
	"b156": "Synchronize",
	"b157": "Invalid range selection.",
	"b158": "User “{{.a}}” synchronized weld schedule “{{.d}}” from machine “{{.c}}” (machine ID {{.b}}) to the offline library.",
	"b159": "Synchronization completed successfully.",
	"b160": "Synchronization failed.",
	"b161": "User “{{.a}}” saved offline-library weld schedule “{{.c}}” for machine ID “{{.b}}”.",
	"b162": "Saved successfully.",
	"b163": "Save failed.",
	"b164": "User “{{.a}}” synchronized offline-library weld schedule “{{.c}}” to machine ID {{.b}}.",
	"b165": "Export Weld Schedule Parameters",
	"b166": "Pre-Weld Control Mode",
	"b167": "Weld 1 Control Mode",
	"b168": "Weld 2 Control Mode",
	"b169": "Weld 3 Control Mode",
	"b170": "Post-Weld Control Mode",
	"b171": "Importing will overwrite the existing data. Continue?",
	"b172": "This file cannot be imported to the selected machine.",
	"b173": "User “{{.a}}” imported weld schedule “{{.c}}” to machine ID {{.b}}.",
	"b174": "User “{{.a}}” imported offline-library weld schedule “{{.c}}” for machine ID {{.b}}.",
	"b175": "Import completed. {{.a}} records were imported.",
	"b176": "Details",
	"b177": "Select the records to delete.",
	"b178": "Failed to delete the records.",
	"b179": "Records deleted successfully.",
	"b180": "Delete the selected records?",
	"b181": "Confirm",
	"b182": "Cancel",
	"b183": "An error occurred while retrieving weld records. Please try again later.",
	"b184": "Active Weld Schedule No.",
	"b185": "Current Sequence Stage",
	"b186": "Current Stage Elapsed Time",
	"b187": "The record does not exist.",
	"b188": "Search failed. No matching weld curve was found.",
	"b189": "An error occurred while retrieving alarm records. Please try again later.",
	"b190": "An error occurred while retrieving change records. Please try again later.",
	"b191": "Weld Schedule Details",
	"b192": "Click “Download” to apply the “Clear” operation!",
	"b193": "Force is outside the valid range.",
	"b194": "Sheet thickness is outside the valid range.",
	"b195": "Row",
	"b196": "Already Exists",
	"b197": "Another task is running. Processing is temporarily unavailable.",
	"b198": "Weld Spot Management: import completed successfully.",
	"b199": "Weld Spot Management: import failed.",
	"b200": "Weld Spot Management: validation completed successfully.",
	"b201": "Weld Spot Management: validation failed.",
	"b202": "Weld Spot Management: clear operation completed successfully.",
	"b203": "Weld Spot Management: clear operation failed.",
	"b204": "Force is outside the range (0–65535).",
	"b205": "Sheet thickness is outside the range (0–655.35).",
	"b206": "Select a weld schedule. If none exists, create one first!",
	"b207": "Weld Spot Management: import completed successfully.",
	"b208": "Weld Spot Management: import failed.",
	"b209": "Failed to delete local weld spot data.",
	"b210": "Unable to create the weld spot.",
	"b211": "The start parameter is missing!",
	"b212": "The start parameter must be an integer!",
	"b213": "The end parameter is missing!",
	"b214": "The end parameter must be an integer!",
	"b215": "Pulse-Width Reference Value",
	"b216": "Accumulated Pulse Width",
	"b217": "Pulse-Width Count",
	"b218": "Weld Spot Management: download failed.",
	"b219": "The pulse-width count can only be reset to 0.",
	"b220": "The pulse-width count can only be reset to 0. Resetting it also resets the pulse-width reference and accumulated pulse width to 0.",
	"b221": "The source and target machine types do not match.",
	"b222": "Function Center",
	"b223": "The current program parameters have been modified but not downloaded to the device. Download before leaving?",
	"b224": "Leave Now",
	"r001": "Machine Status",
	"r002": "Operation",
	"r003": "Tip Dressing",
	"r004": "Welding",
	"r005": "Check",
	"r006": "Force Test",
	"r007": "Trial Weld",
	"r008": "Alarm",
	"r009": "View Alarm Records",
	"r010": "I/O Status",
	"r011": "Weld Waveforms",
	"r012": "Controller Information",
	"r013": "Real-Time Data",
	"r014": "Weld Count per Workpiece",
	"r015": "Shift Production Count",
	"r016": "Total Production Count",
	"r017": "Total Weld Count",
	"r018": "Completed Stepping Stages",
	"r019": "Completed Tip Dressings",
	"r020": "DC Bus Voltage",
	"r021": "Expulsion Count for Active Weld Schedule",
	"r022": "Total Expulsion Count",
	"r023": "Controller Hardware Version",
	"r024": "Controller Software Version",
	"r025": "CPLD Software Version",
	"r026": "Bootloader Version",
	"r027": "Electrode",
	"r028": "Input",
	"r029": "Output",
	"r030": "Start Signal 1",
	"r031": "Start Signal 2",
	"r032": "Program Select 1",
	"r033": "Program Select 2",
	"r034": "Program Select 4",
	"r035": "Program Select 8",
	"r036": "Program Select 16",
	"r037": "Program Select 32",
	"r038": "Check / Weld",
	"r039": "Alarm Reset",
	"r040": "Operation / Tip Dressing",
	"r041": "Emergency Stop",
	"r042": "Transformer Temperature Switch",
	"r043": "Inverter Temperature Switch",
	"r044": "Water Flow Switch",
	"r045": "Air-Pressure Switch",
	"r046": "Weld Enable",
	"r047": "Reserved",
	"r048": "Counter Reset",
	"r049": "Program Select 64",
	"r050": "Program Select 128",
	"r051": "Program Select 256",
	"r052": "Program Select 512",
	"r053": "Electrode Tip-Dressing Confirmation",
	"r054": "Electrode Replacement Confirmation",
	"r055": "Reserved 28",
	"r056": "Reserved 29",
	"r057": "Reserved 30",
	"r058": "Reserved 31",
	"r059": "Machine Ready",
	"r060": "Air Valve 1",
	"r061": "Air Valve 2",
	"r062": "Air Valve 3",
	"r063": "Air Valve 4",
	"r064": "Weld Complete",
	"r065": "IGBT Trigger",
	"r066": "Weld Request",
	"r067": "Motor Output",
	"r068": "Alarm Output",
	"r069": "Electrode Tip Dressing",
	"r070": "Electrode Replacement",
	"r071": "Tip-Dressing Valve",
	"r072": "Sequence Complete",
	"r073": "Reserved 20",
	"r074": "Reserved 21",
	"r075": "Reserved 22",
	"r076": "Reserved 23",
	"r077": "Reserved 24",
	"r078": "Reserved 25",
	"r079": "Reserved 26",
	"r080": "Reserved 27",
	"r081": "Current",
	"r082": "Voltage",
	"r083": "Resistance",
	"r084": "Force",
	"r085": "Acquisition Settings",
	"r086": "Settings",
	"r087": "Acquire Current Curve",
	"r088": "Acquire Resistance Curve",
	"r089": "Acquire Voltage Curve",
	"r090": "Acquire Force Curve",
	"r091": "Settings saved successfully.",
	"r092": "Failed to update curve-acquisition settings.",
	"r093": "Curve-acquisition settings updated successfully.",
	"r094": "Unknown operation type.",
	"r095": "Invalid machine ID.",
	"r096": "The machine is offline. This operation is not allowed.",
	"r097": "Operation completed successfully.",
	"r098": "Operation failed.",
	"r099": "Unknown operation: {{.a}}",
	"r100": "No display-parameter data was found.",
	"r101": "Weld Data",
	"r102": "Statistical Data",
	"r103": "Count",
	"r104": "View",
	"r105": "Weld Record No.",
	"r106": "Controller Software Version",
	"r107": "Weld Spot Management: refresh completed successfully.",
	"r108": "Weld Spot Management: refresh failed.",
	"r109": "Imported data will be merged with existing data. Continue?",
	"r110": "Error querying weld spot information.",
	"r111": "This operation is not allowed in Trial-Weld or Force-Test mode.",
	"r112": "This operation is not allowed in Tip-Dressing mode.",
	"r113": "Feature under development.",
	"r114": "Drag to select an area and zoom in. Double-click to restore the default scale.",
	"r115": "Unable to read the system file.",
	"r116": "Confirm New Weld Spot",
	"r117": "Select New Weld Spot",
	"r118": "Show Expulsion Points",
	"r119": "Trend Monitoring",
	"r120": "View Parameters",
	"r121": "Trend",
	"r122": "Weld 1 Current (kA)",
	"r123": "Weld 2 Current (kA)",
	"r124": "Weld 3 Current (kA)",
	"r125": "Record Limit",
	"r126": "Invalid weld schedule parameter input.",
	"r127": "Pre-Weld Current (kA)",
	"r128": "Post-Weld Current (kA)",
	"r129": "UIP",
	"r130": "Separate multiple weld schedule numbers with commas.",
	"r131": "Enter a weld schedule number.",
	"r132": "The weld schedule number must be an integer.",
	"r133": "The weld spot mapping number must be an integer.",
	"r134": "Enter a valid weld spot quantity.",
	"r135": "The real-time weld spot count cannot exceed 1000.",
	"r136": "Weld Curve",
	"r137": "Real Time",
	"r138": "History",
	"r139": "Real-time data can only query weld records from the past week.",
	"r140": "The historical weld spot count cannot exceed 10000.",
	"r141": "Resistance Reference Curve",
	"r142": "Weld Schedule Energy Reference, Low Word",
	"r143": "Weld Schedule Energy Reference, High Word",
	"r144": "Weld Schedule Energy Reference",
	"r145": "Edit UIR Curve",
	"r146": "Safety Light Curtain Activated",
	"r147": "Chiller Alarm",
	"r148": "Control Cabinet Door Alarm",
	"r149": "Welding Controller Fault",
	"r150": "Inlet Air Pressure Error",
	"r151": "Water Flow Error",
	"r152": "Water Temperature Error",
	"r153": "Water Temperature Upper Limit Alarm",
	"r154": "Water Temperature Lower Limit Alarm",
	"r155": "Weld Pressure Upper Limit Alarm",
	"r156": "Weld Pressure Lower Limit Alarm",
	"r157": "Fusion Threshold Upper Limit Alarm",
	"r158": "Fusion Threshold Lower Limit Alarm",
	"r159": "Electrode 1 Fixed Electrode Locating Pin Not Extended",
	"r160": "Electrode 1 Fixed Electrode Locating Pin Not Retracted",
	"r161": "Electrode 1 Movable Electrode Not at Upper Home Position",
	"r162": "Electrode 1 Movable Electrode Not at Lower Advanced Position",
	"r163": "Electrode 1 Movable Electrode Not at Small-Open Position",
	"r164": "Electrode 1 Movable Electrode Locating Pin Not Extended",
	"r165": "Electrode 1 Movable Electrode Locating Pin Not Retracted",
	"r166": "Electrode 2 Fixed Electrode Locating Pin Not Extended",
	"r167": "Electrode 2 Fixed Electrode Locating Pin Not Retracted",
	"r168": "Electrode 2 Movable Electrode Not at Upper Home Position",
	"r169": "Electrode 2 Movable Electrode Not at Lower Advanced Position",
	"r170": "Electrode 2 Movable Electrode Not at Small-Open Position",
	"r171": "Electrode 2 Movable Electrode Locating Pin Not Extended",
	"r172": "Electrode 2 Movable Electrode Locating Pin Not Retracted",
	"r173": "Conveyor 1 Not at Home Position",
	"r174": "Conveyor 2 Not at Home Position",
	"r175": "Conveyor 3 Not at Home Position",
	"r176": "Conveyor 4 Not at Home Position",
	"r177": "Conveyor 1 Not at Advanced Position",
	"r178": "Conveyor 2 Not at Advanced Position",
	"r179": "Conveyor 3 Not at Advanced Position",
	"r180": "Conveyor 4 Not at Advanced Position",
	"r181": "Conveyor 1 General Alarm",
	"r182": "Conveyor 1 Error: Material Shortage Alarm",
	"r183": "Conveyor 1 Error: Lift Cylinder Advanced Position Alarm",
	"r184": "Conveyor 1 Error: Lift Cylinder Home Position Alarm",
	"r185": "Conveyor 1 Error: Home Position Alarm",
	"r186": "Conveyor 1 Error: Advanced Position Alarm",
	"r187": "Conveyor 2 General Alarm",
	"r188": "Conveyor 2 Error: Material Shortage Alarm",
	"r189": "Conveyor 2 Error: Lift Cylinder Advanced Position Alarm",
	"r190": "Conveyor 2 Error: Lift Cylinder Home Position Alarm",
	"r191": "Conveyor 2 Error: Home Position Alarm",
	"r192": "Conveyor 2 Error: Advanced Position Alarm",
	"r193": "Conveyor 3 General Alarm",
	"r194": "Conveyor 3 Error: Material Shortage Alarm",
	"r195": "Conveyor 3 Error: Lift Cylinder Advanced Position Alarm",
	"r196": "Conveyor 3 Error: Lift Cylinder Home Position Alarm",
	"r197": "Conveyor 3 Error: Home Position Alarm",
	"r198": "Conveyor 3 Error: Advanced Position Alarm",
	"r199": "Conveyor 4 General Alarm",
	"r200": "Conveyor 4 Error: Material Shortage Alarm",
	"r201": "Conveyor 4 Error: Lift Cylinder Advanced Position Alarm",
	"r202": "Conveyor 4 Error: Lift Cylinder Home Position Alarm",
	"r203": "Conveyor 4 Error: Home Position Alarm",
	"r204": "Conveyor 4 Error: Advanced Position Alarm",
	"r205": "Electrode 1 Movable Electrode Tip-Dressing Alarm",
	"r206": "Electrode 1 Fixed Electrode Tip-Dressing Alarm",
	"r207": "Electrode 1 Movable Electrode Replacement Alarm",
	"r208": "Electrode 1 Fixed Electrode Replacement Alarm",
	"r209": "Electrode 2 Movable Electrode Tip-Dressing Alarm",
	"r210": "Electrode 2 Fixed Electrode Tip-Dressing Alarm",
	"r211": "Electrode 2 Movable Electrode Replacement Alarm",
	"r212": "Electrode 2 Fixed Electrode Replacement Alarm",
	"r213": "Electrode 1 Nut/Bolt Mistake-Proofing Check: Check for Missing, Tilted, or Wrong Nut/Bolt Model",
	"r214": "Electrode 1 Nut/Bolt Mistake-Proofing Check: Check for Stacked Objects on the Nut/Bolt",
	"r215": "Electrode 1 Nut/Bolt Mistake-Proofing Check: Check if the Nut Is Reversed or Bolt Model Is Wrong",
	"r216": "Electrode 2 Nut/Bolt Mistake-Proofing Check: Check for Missing, Tilted, or Wrong Nut/Bolt Model",
	"r217": "Electrode 2 Nut/Bolt Mistake-Proofing Check: Check for Stacked Objects on the Nut/Bolt",
	"r218": "Electrode 2 Nut/Bolt Mistake-Proofing Check: Check if the Nut Is Reversed or Bolt Model Is Wrong",
	"r219": "Workpiece Weld Spots Full. Clear the Count.",
	"r220": "Pre-Feed Function Not Enabled",
	"r221": "Not in Component Configuration Mode",
	"r222": "Welding Controller Not Ready",
	"r223": "System Not in Check Mode for Tip Dressing",
	"r224": "System Not in Check Mode for Calibration",
	"r225": "Robotic Arm Feed Not Complete",
	"r226": "System Not in Automatic Mode",
	"r227": "System Not in Manual Mode",
	"r228": "System Not in Online Mode",
	"r229": "System Not in Standalone Mode",
	"r230": "System Not in Tip-Dressing Mode",
	"r231": "Remote Control Not Enabled",
	"r232": "Robot Not Ready",
	"r233": "Electrode 1 Zero Position Not Calibrated",
	"r234": "Electrode 2 Zero Position Not Calibrated",
	"r235": "Electrode 1 Not in Remote Tip-Dressing Mode",
	"r236": "Electrode 1 Not in Remote Operation Mode",
	"r237": "Electrode 2 Not in Remote Tip-Dressing Mode",
	"r238": "Electrode 2 Not in Remote Operation Mode",
	"r239": "Automatic Process Timeout: Locating Pin Operation Before Conveyor Feed",
	"r240": "Automatic Process Timeout: Pre-Feed",
	"r241": "Automatic Process Timeout: Conveyor Feed",
	"r242": "Automatic Process Timeout: Locating Pin Operation Before Pre-Squeeze",
	"r243": "Automatic Process Timeout: Pre-Squeeze",
	"r244": "Automatic Process Timeout: Nut/Bolt Detection",
	"r245": "Automatic Process Timeout: Pressurization",
	"r246": "Automatic Process Timeout: Pressure Detection",
	"r247": "Automatic Process Timeout: Pre-Weld Preparation",
	"r248": "Automatic Process Timeout: Discharge Enable",
	"r249": "Automatic Process Timeout: Welding",
	"r250": "Automatic Process Timeout: Hold",
	"r251": "Automatic Process Timeout: Return Stroke",
	"r252": "Automatic Process Timeout: Weld Complete Pulse",
	"r253": "Nut Detection Timeout",
	"r254": "Pressurization Pressure Detection Timeout",
	"r255": "System Reset Return Stroke Timeout",
	"r256": "Process Reset Return Stroke Timeout",
	"r257": "Displacement Recording Timeout: Return Stroke",
	"r258": "Position Recording Timeout: Locating Pin Before Conveyor Feed Stage",
	"r259": "Position Recording Timeout: Conveyor Feed Stage",
	"r260": "Position Recording Timeout: Locating Pin Before Electrode Press-Down Stage",
	"r261": "Position Recording Timeout: Zero-Point Calibration Stage",
	"r262": "Position Recording Timeout: Electrode Press-Down Stage",
	"r263": "Position Recording Timeout: Filtering Stage",
	"r264": "Position Recording Timeout: Return Stroke Stage",
	"r265": "Workpiece Weld-Spot Interval Timeout (Special Clear)",
	"r266": "Single-Workpiece Welding Timeout (Special Clear)",
	"r267": "Recipe Configuration Error: Nut Feeder Must Be Configured in Online Mode",
	"r268": "Recipe Configuration Error: This Machine Does Not Have Conveyor 1",
	"r269": "Recipe Configuration Error: This Machine Does Not Have Conveyor 2",
	"r270": "Recipe Configuration Error: This Machine Does Not Have Conveyor 3",
	"r271": "Recipe Configuration Error: This Machine Does Not Have Conveyor 4",
	"r272": "Recipe Configuration Error: Nut Feeder 1 Does Not Support the Selected Operation Mode",
	"r273": "Recipe Configuration Error: Nut Feeder 2 Does Not Support the Selected Operation Mode",
	"r274": "Recipe Configuration Error: Electrode 1 Has No Displacement Sensor, Nut Detection Not Supported",
	"r275": "Recipe Configuration Error: Electrode 2 Has No Displacement Sensor, Nut Detection Not Supported",
	"r276": "Recipe Configuration Error: Electrode 1 Has No Air Pressure Sensor or Load Cell, Weld Force Cannot Be Detected",
	"r277": "Recipe Configuration Error: Electrode 2 Has No Air Pressure Sensor or Load Cell, Weld Force Cannot Be Detected",
	"r278": "Recipe Configuration Error: Electrode 1 Has No Upper Locating Pin",
	"r279": "Recipe Configuration Error: Electrode 2 Has No Upper Locating Pin",
	"r280": "Recipe Configuration Error: Electrode 1 Has No Force Booster Valve",
	"r281": "Recipe Configuration Error: Electrode 2 Has No Force Booster Valve",
	"r282": "Recipe Configuration Error: Electrode 1 Does Not Support Electrode Stroke Control",
	"r283": "Recipe Configuration Error: Electrode 2 Does Not Support Electrode Stroke Control",
	"r284": "Recipe Configuration Error: No Conveyor Configured, Pre-Feed Not Supported",
	"r285": "Current Recipe Pre-Squeeze Pressure Value Error",
	"r286": "Current Recipe Pressurization Pressure Value Error",
	"r287": "Current Recipe Return Stroke Pressure Value Error",
	"r288": "Current Recipe Return Stroke Pressure Setting Error. Using System Default Return Stroke Pressure for This Cycle.",
	"r289": "Moving Electrode Return Stroke Pressure Setting Error",
	"r290": "Nut/Bolt Detection: Pre-Squeeze Pressure in Recipe Cannot Be 0",
	"r291": "System Parameters: Manual Pre-Squeeze Pressure Cannot Be Zero",
	"r292": "System Parameters: Manual Pressurization Pressure Cannot Be Zero",
	"r293": "System Parameters: Tip-Dressing Pressure Value Error",
	"r294": "System Parameters: Pre-Squeeze Pressure Value Error",
	"r295": "System Parameters: Pressurization Pressure Value Error",
	"r296": "System Parameters: Pressure Unit Error",
	"r297": "This Machine Does Not Have Conveyor 1",
	"r298": "This Machine Does Not Have Conveyor 2",
	"r299": "This Machine Does Not Have Conveyor 3",
	"r300": "This Machine Does Not Have Conveyor 4",
	"r301": "Electrode 1 Has No Upper Locating Pin",
	"r302": "Electrode 1 Has No Movable Electrode Position Sensor",
	"r303": "Electrode 1 Has No Fixed Electrode Position Sensor",
	"r304": "Electrode 1 Has No Force Booster Valve",
	"r305": "Electrode 1 Has No Stroke Valve",
	"r306": "Electrode 2 Has No Upper Locating Pin",
	"r307": "Electrode 2 Has No Movable Electrode Position Sensor",
	"r308": "Electrode 2 Has No Fixed Electrode Position Sensor",
	"r309": "Electrode 2 Has No Force Booster Valve",
	"r310": "Electrode 2 Has No Stroke Valve",
	"r311": "Electrode 1 Pressure Acquisition Error",
	"r312": "Electrode 1 Tip-Dressing Error",
	"r313": "Electrode 1 Nut/Bolt Position Recording Error",
	"r314": "Electrode 1 Fixed Electrode Initial Position Recording Error",
	"r315": "Electrode 1 Fixed Electrode Tip-Dressing Offset Recording Error",
	"r316": "Electrode 1 Zero-Position Calibration Error",
	"r317": "Electrode 1 Movable Electrode Operation Error",
	"r318": "Electrode 1 Nut/Bolt Mistake-Proofing Check: Upper Electrode Displacement Clear Error",
	"r319": "Electrode 1 Nut/Bolt Mistake-Proofing Check: Lower Locating Pin Displacement Clear Error",
	"r320": "Electrode 1 Manual Pressurization Error",
	"r321": "Electrode 1 Manual Pre-Squeeze Error",
	"r322": "Electrode 1 Locating Pin Information Update Error",
	"r323": "Electrode 1 Nut/Bolt Position Recording: Locating Pin Threshold Update Error",
	"r324": "Electrode 2 Pressure Acquisition Error",
	"r325": "Electrode 2 Tip-Dressing Error",
	"r326": "Electrode 2 Nut/Bolt Position Recording Error",
	"r327": "Electrode 2 Fixed Electrode Initial Position Recording Error",
	"r328": "Electrode 2 Fixed Electrode Tip-Dressing Offset Recording Error",
	"r329": "Electrode 2 Zero-Position Calibration Error",
	"r330": "Electrode 2 Movable Electrode Operation Error",
	"r331": "Electrode 2 Nut/Bolt Mistake-Proofing Check: Upper Electrode Displacement Clear Error",
	"r332": "Electrode 2 Nut/Bolt Mistake-Proofing Check: Lower Locating Pin Displacement Clear Error",
	"r333": "Electrode 2 Manual Pressurization Error",
	"r334": "Electrode 2 Manual Pre-Squeeze Error",
	"r335": "Electrode 2 Locating Pin Information Update Error",
	"r336": "Welding Controller Startup Error",
	"r337": "Recipe Save Failed. Check the Recipe Values.",
	"r338": "Recipe Read Failed",
	"r339": "System Parameter Save Failed. Check the Values.",
	"r340": "Time Setting Error",
	"r341": "Time Calibration Error",
	"r342": "Read Recipe Number Does Not Match Target Recipe Number",
	"r343": "Conveyor Configuration Error",
	"r344": "Unknown Command",
	"r345": "Recipe Number Error",
	"r346": "Component Configuration Error",
	"r347": "Unknown Start Mode",
	"r348": "Calibration Parameter Save Failed",
	"r349": "Welding Machine New Weld Spot Clear Error",
	"r350": "Insufficient Calibration Points. At Least Two Calibration Points Are Required.",
	"r351": "System Parameter Import Error",
	"r352": "Machine Hardware Configuration Table Import Error",
	"r353": "Count Statistics Data Import Error",
	"r354": "Recipe Import Error",
	"r355": "Calibration Parameter Import Error",
	"r356": "Modbus RTU Master 0 Init Error",
	"r357": "Modbus RTU Master 0 Enable Error",
	"r358": "Modbus RTU Master 0 Task Manager Binding Error",
	"r359": "Modbus RTU Master 1 XoneInit Error",
	"r360": "Modbus RTU Master 1 Xone Enable Error",
	"r361": "Modbus RTU Master 1 Xone Task Manager Binding Error",
	"r362": "Modbus TCP Init Error",
	"r363": "Modbus TCP Enable Error",
	"r364": "TIM7 Start Error",
	"r365": "Log Initialization Error",
	"r366": "Log Runtime Error",
	"r367": "Real-Time Clock Start Error",
	"r368": "Real-Time Clock Time Error",
	"r369": "Digital I/O Initialization Error",
	"r370": "State Machine Initialization Error",
	"r371": "Modbus Master Task Manager 0 Error",
	"r372": "Modbus Master Task Manager 1 Xone Error",
	"r373": "Welding Machine Control Block Configuration Error",
	"r374": "Nut/Bolt Mistake-Proofing Check: Movable Electrode Displacement Configuration Error",
	"r375": "Nut/Bolt Mistake-Proofing Check: Fixed Electrode Locating Pin Displacement Configuration Error",
	"r376": "Welding Machine Control Command Execution Failed",
	"r377": "DIO Module Data Transfer Error",
	"r378": "DIO Module SPI Error",
	"r379": "ADC Module Data Transfer Error",
	"r380": "ADC Module SPI Error",
	"r381": "Anybus Module Serial Port Error",
	"r382": "ModbusRTU Module Serial Port Error",
	"r383": "System Power Loss Detected",
	"r384": "Count Statistics Data Save Error",
	"r385": "Count Statistics Data Validation Error",
	"r386": "Two-Hand Start Function Module Error",
	"r387": "Countdown Timer Stop Error",
	"r388": "Countdown Timer Start Error",
	"r389": "Event Unsubscription Error",
	"r390": "Event Subscription Error",
	"r391": "State Transition Recording Error",
	"r392": "I/O Power Control Error",
	"r393": "State Exit Error",
	"r394": "State Entry Error",
	"r395": "Alarm State Entry Error",
	"r396": "Alarm State Exit Error",
	"r397": "Locating Pin Position Control Information Update Error",
	"r398": "Status Indication Error",
	"r399": "Digital Input Flag Clear Error",
	"r400": "Digital Input Event Subscription Error",
	"r401": "Conveyor 1 Control Error",
	"r402": "Conveyor 2 Control Error",
	"r403": "Conveyor 3 Control Error",
	"r404": "Conveyor 4 Control Error",
	"s001": "System Logs",
	"s002": "No.",
	"s003": "Operator",
	"s004": "Object ID",
	"s005": "Summary",
	"s006": "Operation Time",
	"s007": "Calibration Stage Status",
	"s008": "Stage Selection",
	"s009": "Enable controller ready state and start normal operation",
	"s010": "Enable controller welding",
	"s011": "Host I/O Status",
	"s012": "Error-Clear Command",
	"s013": "Current PWM Output Setpoint",
	"s014": "Electrode-Force Output Setpoint",
	"s015": "DC Bus Voltage Display Value",
	"s016": "Primary Current Display Value",
	"s017": "Secondary Current Display Value",
	"s018": "Electrode Force Display Value",
	"s019": "Weld Counter Reset Command",
	"s020": "PROFIBUS Input Status Word 00",
	"s021": "PROFIBUS Input Status Word 01",
	"s022": "PROFIBUS Output Status Word 00",
	"s023": "PROFIBUS Output Status Word 01",
	"s024": "DeviceNet Input Status Word 00",
	"s025": "DeviceNet Input Status Word 01",
	"s026": "DeviceNet Output Status Word 00",
	"s027": "DeviceNet Output Status Word 00",
	"s028": "Click or drag and drop a file here to upload it.",
	"s029": "Import Completed",
	"s030": "Refresh",
	"s031": "Validate",
	"s032": "Clear",
	"s033": "Create Weld Spot",
	"s034": "Edit Weld Spot",
	"s035": "Reserved",
	"s036": "Historical Alarm Table Address Pointer",
	"s037": "Alarm Status Word (0–31)",
	"s038": "Pre-Weld Force",
	"s039": "Cooling Force 0",
	"s040": "Upslope Force",
	"s041": "Weld 1 Force",
	"s042": "Cooling Force 1",
	"s043": "Cooling Force 2",
	"s044": "Weld 3 Force",
	"s045": "Downslope Force",
	"s046": "Cooling Force 3",
	"s047": "Post-Weld Force",
	"s048": "Hold Force",
	"s049": "Vehicle model currently produced by Weld Gun 1, field 00 (stored as ASCII code)",
	"s050": "Vehicle model currently produced by Weld Gun 1, field 01 (stored as ASCII code)",
	"s051": "Vehicle model currently produced by Weld Gun 1, field 02 (stored as ASCII code)",
	"s052": "Vehicle model currently produced by Weld Gun 1, field 03 (stored as ASCII code)",
	"s053": "Vehicle model currently produced by Weld Gun 2, field 00 (stored as ASCII code)",
	"s054": "Vehicle model currently produced by Weld Gun 2, field 01 (stored as ASCII code)",
	"s055": "Vehicle model currently produced by Weld Gun 2, field 02 (stored as ASCII code)",
	"s056": "Vehicle model currently produced by Weld Gun 2, field 03 (stored as ASCII code)",
	"s057": "Electrode-Force Mode",
	"s058": "Start 2 Function Selection",
	"s059": "Weld Spot Confirmation Function Selection",
	"s060": "Reweld Count",
	"s061": "Force-Test Setpoint",
	"s062": "Controller CPLD Software Version",
	"s063": "Communication Interface Selection",
	"s064": "Communication Address",
	"s065": "Network Function",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Device Serial Number",
	"s069": "DeviceNet Baud Rate",
	"s070": "Rated Voltage",
	"s071": "Number of Inverters",
	"s072": "Weld Enable Function Selection",
	"s073": "Transformer Turns Ratio",
	"s074": "Transformer Efficiency",
	"s075": "Constant-Current Control Mode",
	"s076": "Primary-Current Threshold",
	"s077": "IGBT Protection Alarm Reset Control",
	"s078": "HMI Emergency-Stop Function Selection",
	"s079": "Program-Group Priority Selection Function",
	"s080": "Proportional Pressure Regulator Function Selection",
	"s081": "Controller Standalone Operation Without HMI",
	"s082": "Large-Opening Operation Trigger Mode",
	"s083": "Electrode Tip-Dressing Confirmation Function",
	"s084": "Delayed start of weld-gun small opening in suspended-gun welding",
	"s085": "Ratio of Weld Gun 1 Rogowski-coil current sample to actual current",
	"s086": "Ratio of Weld Gun 2 Rogowski-coil current sample to actual current",
	"s087": "Ratio of Weld Gun 1 CT current sample to actual current",
	"s088": "Ratio of Weld Gun 2 CT current sample to actual current",
	"s089": "Maximum actual current supported by the system for Weld Gun 1",
	"s090": "Maximum actual current supported by the system for Weld Gun 2",
	"s091": "Current power-factor angle for Weld Gun 1",
	"s092": "Current power-factor angle for Weld Gun 2",
	"s093": "Current weld trigger-control angle",
	"s094": "Electrode-arm opening state after power-off for a suspended-gun welding controller",
	"s095": "Output mode of the Weld Complete and Sequence Complete signals",
	"s096": "DC bus voltage display coefficient (this parameter is no longer used)",
	"s097": "Weld Gun 1 Minimum Primary-Current PWM Output Setpoint",
	"s098": "Weld Gun 1 Level 1 Primary-Current PWM Output Setpoint",
	"s099": "Weld Gun 1 Level 2 Primary-Current PWM Output Setpoint",
	"s100": "Weld Gun 1 Level 3 Primary-Current PWM Output Setpoint",
	"s101": "Weld Gun 1 Level 4 Primary-Current PWM Output Setpoint",
	"s102": "Weld Gun 1 Level 5 Primary-Current PWM Output Setpoint",
	"s103": "Weld Gun 1 Level 6 Primary-Current PWM Output Setpoint",
	"s104": "Weld Gun 1 Maximum Primary-Current PWM Output Setpoint",
	"s105": "Weld Gun 1 Minimum Primary-Current Sample Value",
	"s106": "Weld Gun 1 Level 1 Primary-Current Sample Value",
	"s107": "Weld Gun 1 Level 2 Primary-Current Sample Value",
	"s108": "Weld Gun 1 Level 3 Primary-Current Sample Value",
	"s109": "Weld Gun 1 Level 4 Primary-Current Sample Value",
	"s110": "Weld Gun 1 Level 5 Primary-Current Sample Value",
	"s111": "Weld Gun 1 Level 6 Primary-Current Sample Value",
	"s112": "Weld Gun 1 Maximum Primary-Current Sample Value",
	"s113": "Weld Gun 1 Minimum Primary-Current Display Value",
	"s114": "Weld Gun 1 Level 1 Primary-Current Display Value",
	"s115": "Weld Gun 1 Level 2 Primary-Current Display Value",
	"s116": "Weld Gun 1 Level 3 Primary-Current Display Value",
	"s117": "Weld Gun 1 Level 4 Primary-Current Display Value",
	"s118": "Weld Gun 1 Level 5 Primary-Current Display Value",
	"s119": "Weld Gun 1 Level 6 Primary-Current Display Value",
	"s120": "Weld Gun 1 Maximum Primary-Current Display Value",
	"s121": "Weld Gun 1 Minimum Secondary-Current PWM Output Setpoint",
	"s122": "Weld Gun 1 Level 1 Secondary-Current PWM Output Setpoint",
	"s123": "Weld Gun 1 Level 2 Secondary-Current PWM Output Setpoint",
	"s124": "Weld Gun 1 Level 3 Secondary-Current PWM Output Setpoint",
	"s125": "Weld Gun 1 Level 4 Secondary-Current PWM Output Setpoint",
	"s126": "Weld Gun 1 Level 5 Secondary-Current PWM Output Setpoint",
	"s127": "Weld Gun 1 Level 6 Secondary-Current PWM Output Setpoint",
	"s128": "Weld Gun 1 Maximum Secondary-Current PWM Output Setpoint",
	"s129": "Weld Gun 1 Minimum Secondary-Current Sample Value",
	"s130": "Weld Gun 1 Level 1 Secondary-Current Sample Value",
	"s131": "Weld Gun 1 Level 2 Secondary-Current Sample Value",
	"s132": "Weld Gun 1 Level 3 Secondary-Current Sample Value",
	"s133": "Weld Gun 1 Level 4 Secondary-Current Sample Value",
	"s134": "Weld Gun 1 Level 5 Secondary-Current Sample Value",
	"s135": "Weld Gun 1 Level 6 Secondary-Current Sample Value",
	"s136": "Weld Gun 1 Maximum Secondary-Current Sample Value",
	"s137": "Weld Gun 1 Minimum Secondary-Current Display Value",
	"s138": "Weld Gun 1 Level 1 Secondary-Current Display Value",
	"s139": "Weld Gun 1 Level 2 Secondary-Current Display Value",
	"s140": "Weld Gun 1 Level 3 Secondary-Current Display Value",
	"s141": "Weld Gun 1 Level 4 Secondary-Current Display Value",
	"s142": "Weld Gun 1 Level 5 Secondary-Current Display Value",
	"s143": "Weld Gun 1 Level 6 Secondary-Current Display Value",
	"s144": "Weld Gun 1 Maximum Secondary-Current Display Value",
	"s145": "Weld Gun 2 Minimum Secondary-Current PWM Output Setpoint",
	"s146": "Weld Gun 2 Level 1 Secondary-Current PWM Output Setpoint",
	"s147": "Weld Gun 2 Level 2 Secondary-Current PWM Output Setpoint",
	"s148": "Weld Gun 2 Level 3 Secondary-Current PWM Output Setpoint",
	"s149": "Weld Gun 2 Level 4 Secondary-Current PWM Output Setpoint",
	"s150": "Weld Gun 2 Level 5 Secondary-Current PWM Output Setpoint",
	"s151": "Weld Gun 2 Level 6 Secondary-Current PWM Output Setpoint",
	"s152": "Weld Gun 2 Maximum Secondary-Current PWM Output Setpoint",
	"s153": "Weld Gun 2 Minimum Secondary-Current Sample Value",
	"s154": "Weld Gun 2 Level 1 Secondary-Current Sample Value",
	"s155": "Weld Gun 2 Level 2 Secondary-Current Sample Value",
	"s156": "Weld Gun 2 Level 3 Secondary-Current Sample Value",
	"s157": "Weld Gun 2 Level 4 Secondary-Current Sample Value",
	"s158": "Weld Gun 2 Level 5 Secondary-Current Sample Value",
	"s159": "Weld Gun 2 Level 6 Secondary-Current Sample Value",
	"s160": "Weld Gun 2 Maximum Secondary-Current Sample Value",
	"s161": "Weld Gun 2 Minimum Secondary-Current Display Value",
	"s162": "Weld Gun 2 Level 1 Secondary-Current Display Value",
	"s163": "Weld Gun 2 Level 2 Secondary-Current Display Value",
	"s164": "Weld Gun 2 Level 3 Secondary-Current Display Value",
	"s165": "Weld Gun 2 Level 4 Secondary-Current Display Value",
	"s166": "Weld Gun 2 Level 5 Secondary-Current Display Value",
	"s167": "Weld Gun 2 Level 6 Secondary-Current Display Value",
	"s168": "Weld Gun 2 Maximum Secondary-Current Display Value",
	"s169": "Weld Gun 1 Electrode-Force Stage 1 Output Setpoint",
	"s170": "Weld Gun 1 Electrode-Force Stage 2 Output Setpoint",
	"s171": "Weld Gun 1 Electrode-Force Stage 1 Measured Display Value",
	"s172": "Weld Gun 1 Electrode-Force Stage 2 Measured Display Value",
	"s173": "Weld Gun 2 Electrode-Force Stage 1 Output Setpoint",
	"s174": "Weld Gun 2 Electrode-Force Stage 2 Output Setpoint",
	"s175": "Weld Gun 2 Electrode-Force Stage 1 Measured Display Value",
	"s176": "Weld Gun 2 Electrode-Force Stage 2 Measured Display Value",
	"s177": "Primary-Current Calibration Parameters",
	"s178": "Secondary-Current Calibration Parameters",
	"s179": "Weld Schedule Selection Mode",
	"s180": "Weld Gun 1 Primary Constant-Current Fine-Adjustment Parameter",
	"s181": "Weld Gun 1 Secondary Constant-Current Fine-Adjustment Parameter",
	"s182": "Weld Gun 2 Primary Constant-Current Fine-Adjustment Parameter",
	"s183": "Weld Gun 2 Secondary Constant-Current Fine-Adjustment Parameter",
	"s184": "Weld Gun B Tip-Dressing Up Pressure",
	"s185": "Weld Gun B Tip-Dressing Pressure",
	"s186": "Weld Gun 1 Process-Weld-Spot Control Function",
	"s187": "Weld Gun 2 Process-Weld-Spot Control Function",
	"s188": "Alarm when the weld count per workpiece reaches the specified process weld count",
	"s189": "Shift-production weld-count alarm function",
	"s190": "Start timing immediately after alarm reset",
	"s191": "Weld Gun 1 Current Weld-Cycle End Detection Time",
	"s192": "Weld Gun 2 Current Weld-Cycle End Detection Time",
	"s193": "Weld Gun 1 Lower Weld-Count Setpoint per Workpiece",
	"s194": "Weld Gun 2 Lower Weld-Count Setpoint per Workpiece",
	"s195": "Weld Gun 1 Upper Weld-Count Setpoint per Workpiece",
	"s196": "Weld Gun 2 Upper Weld-Count Setpoint per Workpiece",
	"s197": "Weld Gun 1 Shift Production Setpoint",
	"s198": "Weld Gun 2 Shift Production Setpoint",
	"s199": "Weld Gun 1 Weld Count per Workpiece",
	"s200": "Weld Gun 2 Weld Count per Workpiece",
	"s201": "Power-Loss-Persistent Counter Alarm Information Value",
	"s202": "Weld Gun Count Configuration Mode",
	"s203": "Weld Gun 1 Stepping-Stage Count Setpoint",
	"s204": "Weld Gun 2 Stepping-Stage Count Setpoint",
	"s205": "Weld Gun 1 Tip-Dressing Count Setpoint",
	"s206": "Weld Gun 2 Tip-Dressing Count Setpoint",
	"s207": "Weld Gun 1 Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"s208": "Weld Gun 2 Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"s209": "Weld Gun 1 Stepping Weld Count 1",
	"s210": "Weld Gun 1 Power Compensation 1",
	"s211": "Weld Gun 1 Force Compensation 1",
	"s212": "Weld Gun 1 Stepping Weld Count 2",
	"s213": "Weld Gun 1 Power Compensation 2",
	"s214": "Weld Gun 1 Force Compensation 2",
	"s215": "Weld Gun 1 Stepping Weld Count 3",
	"s216": "Weld Gun 1 Power Compensation 3",
	"s217": "Weld Gun 1 Force Compensation 3",
	"s218": "Weld Gun 1 Stepping Weld Count 4",
	"s219": "Weld Gun 1 Power Compensation 4",
	"s220": "Weld Gun 1 Force Compensation 4",
	"s221": "Weld Gun 1 Stepping Weld Count 5",
	"s222": "Weld Gun 1 Power Compensation 5",
	"s223": "Weld Gun 1 Force Compensation 5",
	"s224": "Weld Gun 1 Stepping Weld Count 6",
	"s225": "Weld Gun 1 Power Compensation 6",
	"s226": "Weld Gun 1 Force Compensation 6",
	"s227": "Weld Gun 1 Stepping Weld Count 7",
	"s228": "Weld Gun 1 Power Compensation 7",
	"s229": "Weld Gun 1 Force Compensation 7",
	"s230": "Weld Gun 1 Stepping Weld Count 8",
	"s231": "Weld Gun 1 Power Compensation 8",
	"s232": "Weld Gun 1 Force Compensation 8",
	"s233": "Weld Gun 1 Stepping Weld Count 9",
	"s234": "Weld Gun 1 Power Compensation 9",
	"s235": "Weld Gun 1 Force Compensation 9",
	"s236": "Weld Gun 2 Stepping Weld Count 1",
	"s237": "Weld Gun 2 Power Compensation 1",
	"s238": "Weld Gun 2 Force Compensation 1",
	"s239": "Weld Gun 2 Stepping Weld Count 2",
	"s240": "Weld Gun 2 Power Compensation 2",
	"s241": "Weld Gun 2 Force Compensation 2",
	"s242": "Weld Gun 2 Stepping Weld Count 3",
	"s243": "Weld Gun 2 Power Compensation 3",
	"s244": "Weld Gun 2 Force Compensation 3",
	"s245": "Weld Gun 2 Stepping Weld Count 4",
	"s246": "Weld Gun 2 Power Compensation 4",
	"s247": "Weld Gun 2 Force Compensation 4",
	"s248": "Weld Gun 2 Stepping Weld Count 5",
	"s249": "Weld Gun 2 Power Compensation 5",
	"s250": "Weld Gun 2 Force Compensation 5",
	"s251": "Weld Gun 2 Stepping Weld Count 6",
	"s252": "Weld Gun 2 Power Compensation 6",
	"s253": "Weld Gun 2 Force Compensation 6",
	"s254": "Weld Gun 2 Stepping Weld Count 7",
	"s255": "Weld Gun 2 Power Compensation 7",
	"s256": "Weld Gun 2 Force Compensation 7",
	"s257": "Weld Gun 2 Stepping Weld Count 8",
	"s258": "Weld Gun 2 Power Compensation 8",
	"s259": "Weld Gun 2 Force Compensation 8",
	"s260": "Weld Gun 2 Stepping Weld Count 9",
	"s261": "Weld Gun 2 Power Compensation 9",
	"s262": "Weld Gun 2 Force Compensation 9",
	"s263": "Weld Gun 2 Minimum Primary-Current PWM Output Setpoint",
	"s264": "Weld Gun 2 Level 1 Primary-Current PWM Output Setpoint",
	"s265": "Weld Gun 2 Level 2 Primary-Current PWM Output Setpoint",
	"s266": "Weld Gun 2 Level 3 Primary-Current PWM Output Setpoint",
	"s267": "Weld Gun 2 Level 4 Primary-Current PWM Output Setpoint",
	"s268": "Weld Gun 2 Level 5 Primary-Current PWM Output Setpoint",
	"s269": "Weld Gun 2 Level 6 Primary-Current PWM Output Setpoint",
	"s270": "Weld Gun 2 Maximum Primary-Current PWM Output Setpoint",
	"s271": "Weld Gun 2 Minimum Primary-Current Sample Value",
	"s272": "Weld Gun 2 Level 1 Primary-Current Sample Value",
	"s273": "Weld Gun 2 Level 2 Primary-Current Sample Value",
	"s274": "Weld Gun 2 Level 3 Primary-Current Sample Value",
	"s275": "Weld Gun 2 Level 4 Primary-Current Sample Value",
	"s276": "Weld Gun 2 Level 5 Primary-Current Sample Value",
	"s277": "Weld Gun 2 Level 6 Primary-Current Sample Value",
	"s278": "Weld Gun 2 Maximum Primary-Current Sample Value",
	"s279": "Weld Gun 2 Minimum Primary-Current Display Value",
	"s280": "Weld Gun 2 Level 1 Primary-Current Display Value",
	"s281": "Weld Gun 2 Level 2 Primary-Current Display Value",
	"s282": "Weld Gun 2 Level 3 Primary-Current Display Value",
	"s283": "Weld Gun 2 Level 4 Primary-Current Display Value",
	"s284": "Weld Gun 2 Level 5 Primary-Current Display Value",
	"s285": "Weld Gun 2 Level 6 Primary-Current Display Value",
	"s286": "Weld Gun 2 Maximum Primary-Current Display Value",
	"s287": "High 16 Bits of the Power-Loss-Persistent Counter Alarm Information Value",
	"s288": "UIR Adjustment Function Selection",
	"s289": "Weld-Time Extension During UIR Adjustment",
	"s290": "UIR Adjustment Start Time Point",
	"s291": "Maximum UIR Current-Increase Percentage",
	"s292": "Maximum UIR Current-Decrease Percentage",
	"s293": "Maximum UIR Time-Increase Percentage",
	"s294": "Conversion Coefficient from Secondary-Voltage Sample to Display Value",
	"s295": "UIR Monitoring Function Selection",
	"s296": "SD Card Weld-Record Function Selection",
	"s297": "Number of Weld Records per SD Card File",
	"s298": "Number of Weld Files per SD Card Folder",
	"s299": "Dual-Solenoid Large-Opening Function for Suspended-Gun Welding",
	"s300": "Secondary-Resistance Monitoring: 0 = Off, 1 = On",
	"s301": "Global Resistance-Threshold Parameter Selection: 0 = Off, 1 = On",
	"s302": "Internal Offset Address",
	"s303": "DC Bus Voltage During Current Calibration",
	"s304": "Secondary-Voltage Presence Detection",
	"s305": "Time Range",
	"s306": "Within 30 Days",
	"s307": "Within 60 Days",
	"s308": "Within 90 Days",
	"s309": "curves",
	"s310": "Invalid time range.",
	"s311": "Active curve set successfully.",
	"s312": "The selected curve is not valid.",
	"s313": "Invalid curve number.",
	"s314": "The corresponding curve was not found. Deletion failed.",
	"s315": "Deletion failed.",
	"s316": "Deleted successfully.",
	"s317": "Too few samples to generate a reference curve.",
	"s318": "Download the current reference curve to the controller?",
	"s319": "Save the current reference curve to the weld schedule library?",
	"s320": "No reference curve has been generated. Download is unavailable.",
	"s321": "Invalid weld schedule number (0–143).",
	"s322": "Curve data error.",
	"s323": "The reference-curve data is empty and cannot be saved.",
	"s324": "Reference-curve processing error.",
	"s325": "Error saving the reference curve.",
	"s326": "Alarm List",
	"s327": "Execution failed.",
	"s328": "Execution completed successfully.",
	"s329": "Validation failed.",
	"s330": "Executing...",
	"s331": "Because the current-threshold mode is Percentage, {{.a}} must be set to an integer. Check the value. If a changed value has not taken effect, reconnect the machine.",
	"s332": "Debug mode is active. Disable debug mode before leaving.",
	"s333": "Current-Algorithm Adjustment Mode",
	"s334": "Fast",
	"s335": "End Point",
	"s336": "System Configuration",
	"s337": "Concurrent Machine Parameter Backup/Restore Tasks",
	"s338": "HRC-670 Save Directory",
	"s339": "HRC-670 Connection Port",
	"s340": "View System Configuration",
	"s341": "Manage System Configuration",
	"s342": "An error occurred while saving parameters. Please try again later.",
	"s343": "An error occurred while retrieving the system configuration. Please try again later.",
	"s344": "Configuration saved successfully.",
	"s345": "The HRC-670 save directory is required.",
	"s346": "The HRC-670 save-directory path does not exist!",
	"s347": "The number of concurrent machine parameter backup/restore tasks must be a positive integer.",
	"s348": "The number of concurrent machine parameter backup/restore tasks must be within the range 1–8.",
	"s349": "Compatibility Mode Without Weld Spot Mapping",
	"s350": "Indicator Light",
	"s351": "Recording Status",
	"i001": "Data Management",
	"i002": "Clear Data",
	"i003": "Weld Records",
	"i004": "Curve Records",
	"i005": "Alarm Records",
	"i006": "UIR Reference Curves",
	"i007": "Weld Schedule Library Data",
	"i008": "Weld Schedule Cache Data",
	"i009": "System Cache Data",
	"i010": "Change Records",
	"i011": "System Logs",
	"i012": "Warning: Erased data cannot be recovered. Back up the data before erasing it!",
	"i013": "User “{{.a}}” erased {{.b}} data.",
	"i014": "Data erased successfully.",
	"i015": "Failed to erase data.",
	"i016": "Clear by Time Range",
	"i017": "1 Month",
	"i018": "3 Months",
	"i019": "6 Months",
	"i020": "1 Year",
	"i021": "Clear Before:",
	"i022": "Clear Without Time Filter",
	"i023": "User “{{.a}}” cleared {{.b}} data. Clear range:",
	"i024": "Automatic Machine Parameter Backup",
	"i025": "After enabling automatic backup for a machine, select the automatic backup time.",
	"i026": "Rolling Data Retention",
	"i027": "After enabling automatic cleanup, select the records to clean automatically.",
	"i028": "After enabling automatic cleanup, select the time range to clean automatically.",
	"i029": "The cleanup function on this page performs a one-time manual cleanup. For automatic cleanup, go to System -> System Configuration, enable “Rolling Data Retention,” and save the changes.",
	"i030": "TCP Server",
	"i031": "SSH Server",
	"i032": "Permanently Delete",
	"i033": "Delete this machine? Its data cannot be recovered after deletion.",
	"i034": "One Week",
	"h001": "User “{{.a}}” updated weld schedule library entry “{{.b}}” (weld schedule name: “{{.c}}”).",
	"h002": "An error occurred while retrieving system-log data. Please try again later.",
	"h003": "User “{{.a}}” created weld schedule library entry “{{.b}}” (weld schedule name: “{{.c}}”).",
	"h004": "User “{{.a}}” deleted weld schedule library entry “{{.b}}” (weld schedule name: “{{.c}}”).",
	"h005": "User “{{.a}}” created area “{{.b}}”.",
	"h006": "User “{{.a}}” updated area “{{.b}}”.",
	"h007": "User “{{.a}}” deleted area “{{.b}}”.",
	"h008": "User “{{.a}}” restored area “{{.b}}”.",
	"h009": "User “{{.a}}” created machine “{{.b}}”.",
	"h010": "User “{{.a}}” updated machine “{{.b}}”.",
	"h011": "User “{{.a}}” deleted machine “{{.b}}”.",
	"h012": "User “{{.a}}” restored machine “{{.b}}”.",
	"h013": "User “{{.a}}” created user “{{.b}}”.",
	"h014": "User “{{.a}}” updated user “{{.b}}”.",
	"h015": "User “{{.a}}” deleted user “{{.b}}”.",
	"h016": "User “{{.a}}” restored user “{{.b}}”.",
	"h017": "Account “{{.b}}” was locked for 20 minutes after more than {{.a}} incorrect login-password attempts.",
	"h018": "User “{{.a}}” logged in successfully.",
	"h019": "User “{{.a}}” updated the curve-acquisition settings of machine “{{.b}}”.",
	"h020": "User “{{.a}}” created role “{{.b}}”.",
	"h021": "User “{{.a}}” updated role “{{.b}}”.",
	"h022": "User “{{.a}}” deleted role “{{.b}}”.",
	"h023": "User “{{.a}}” restored role “{{.b}}”.",
	"h024": "User “{{.a}}” changed the permissions of role “{{.b}}”.",
	"k001": "Real-Time Monitoring",
	"k002": "Weld Schedule Parameters",
	"k003": "Production Management",
	"k004": "System Parameters",
	"k005": "Weld Records",
	"k006": "Alarm Records",
	"k007": "Change Records",
	"k008": "Weld Spot Management",
	"k009": "Machine",
	"k010": "Offline Library",
	"k011": "Weld Gun Selection",
	"k012": "Expulsion Count",
	"k013": "Expulsion-Detection Threshold",
	"k014": "Expulsion Time-Window Threshold",
	"k015": "Resistance Reference Value",
	"k016": "Minimum Weld-Resistance Threshold",
	"k017": "Maximum Weld-Resistance Threshold",
	"k018": "Invalid weld schedule number.",
	"k019": "Weld schedule “{{.a}}” loaded successfully from the machine.",
	"k020": "Failed to load weld schedule “{{.a}}” from the machine.",
	"k021": "Weld schedule “{{.a}}” loaded successfully from the offline database.",
	"k022": "Failed to load weld schedule “{{.a}}” from the offline database.",
	"k023": "Download",
	"k024": "Machine -> Library",
	"k025": "Export",
	"k026": "Import",
	"k027": "Electrode 1 Calibration",
	"k028": "Electrode 2 Calibration",
	"k029": "Electrode 3 Calibration",
	"k030": "Electrode 4 Calibration",
	"k031": "Electrode 5 Calibration",
	"k032": "UIR Settings",
	"k033": "UIR Curve",
	"k034": "UIP Rectangle Chart",
	"k035": "Software Upgrade",
	"k036": "System Parameter Backup",
	"k037": "Welding Machine Configuration",
	"k038": "Welding Machine Type",
	"k039": "Standard Spot Welding",
	"k040": "Robotic Spot Welding",
	"k041": "Standard Seam Welding",
	"k042": "Special Seam Welding",
	"k043": "Suspended-Gun Welding",
	"k044": "Custom Welding",
	"k045": "Projection Welding",
	"k046": "BYD Suspended-Gun Welding",
	"k047": "Weld Spot Confirmation",
	"k048": "Off",
	"k049": "On",
	"k050": "Transformer Type",
	"k051": "Electrode Tip-Dressing Confirmation",
	"k052": "Weld Complete Signal",
	"k053": "Pulsed",
	"k054": "Level",
	"k055": "Current-Threshold Mode Selection",
	"k056": "Absolute-Value Mode",
	"k057": "Percentage Mode",
	"k058": "UIP Alarm Mode",
	"k059": "Warning",
	"k060": "Stop Machine",
	"k061": "Minimum DC Bus Voltage",
	"k062": "Continuous Welding Mode",
	"k063": "Reference DC Bus Voltage",
	"k064": "Constant-Current Control",
	"k065": "Secondary Constant Current",
	"k066": "Primary Constant Current",
	"k067": "Maximum Electrode Force",
	"k068": "Inverter Output Frequency",
	"k069": "Function Settings",
	"k070": "HMI Emergency Stop",
	"k071": "Proportional Pressure Regulator Function",
	"k072": "Weld Schedule Priority",
	"k073": "Controller Operation Without HMI",
	"k074": "Initial Settings",
	"k075": "Calibration Selection",
	"k076": "Calibrate Electrode Force",
	"k077": "Calibrate Primary Current",
	"k078": "Calibrate Secondary Current",
	"k079": "Calibration Value",
	"k080": "Setpoint (%)",
	"k081": "Measured Value (kN)",
	"k082": "Function Selection",
	"k083": "UIR Monitoring",
	"k084": "Time Compensation",
	"k085": "Start Time",
	"k086": "Function Parameters",
	"k087": "Upper Current-Adjustment Limit",
	"k088": "Lower Current-Adjustment Limit",
	"k089": "Expulsion Time-Window Threshold",
	"k090": "Expulsion-Detection Threshold",
	"k091": "Maximum Time Extension",
	"k092": "Secondary-Voltage Coefficient",
	"k093": "Global Resistance-Threshold Parameter Selection",
	"k094": "Secondary-Resistance Monitoring",
	"k095": "Minimum Weld-Resistance Threshold",
	"k096": "Maximum Weld-Resistance Threshold",
	"k097": "Maximum Time Extension",
	"k098": "Stop UIR Recording",
	"k099": "Weld Spot Count",
	"k100": "Selected Curves",
	"k101": "Weld Time",
	"k102": "Weld Spot No.",
	"k103": "Delete Curve",
	"k104": "Generate Reference Curve",
	"k105": "-> Controller",
	"k106": "UIP Function Selection",
	"k107": "UIP Reference Value",
	"k108": "UIP Upper Tolerance Band",
	"k109": "UIP Lower Tolerance Band",
	"k110": "Controller Upgrade",
	"k111": "Note: The controller can only be upgraded while in standby. Do not switch off the power during the upgrade. Restart the controller after the upgrade is completed.",
	"k112": "Firmware",
	"k113": "Select the controller firmware file.",
	"k114": "Select File",
	"k115": "Upgrade",
	"k116": "Restore Factory Settings",
	"k117": "Note: Restoring the controller to factory settings will erase the existing data.",
	"k118": "Options",
	"k119": "System Parameters",
	"k120": "Restore",
	"k121": "Calibration Parameters",
	"k122": "Secondary-Circuit Impedance",
	"k123": "Weld Enable",
	"k124": "Maximum Secondary Current",
	"k125": "Force Output Mode",
	"k126": "Maximum Weld Time",
	"k127": "Maximum Pulse-Width Variation",
	"k128": "Normal Impedance",
	"k129": "High Impedance",
	"k130": "Low Impedance",
	"k131": "I/O Control Function",
	"k132": "Controller Priority",
	"k133": "RS-485 Priority",
	"k134": "DeviceNet Priority",
	"k135": "Modbus TCP Priority",
	"k136": "ABCC Priority",
	"k137": "Operating-Mode Priority",
	"k138": "Programmer Priority",
	"k139": "Valid-Signal Priority",
	"k140": "Weld Schedule Group Priority",
	"k141": "UIP Settings",
	"k142": "Loaded successfully from the machine.",
	"k143": "Loaded successfully from the offline library.",
	"k144": "Failed to load from the machine.",
	"k145": "Failed to load from the offline library.",
	"k146": "Secondary-Voltage Detection",
	"k147": "Secondary-Voltage Detection",
	"k148": "UIR Adjustment",
	"k149": "Inverter Frequency",
	"k150": "Primary-Current Calibration Selection",
	"k151": "System Default",
	"k152": "User Calibration",
	"k153": "Inverter Frequency",
	"k154": "Primary Fine-Adjustment Coefficient",
	"k155": "Secondary-Current Calibration Selection",
	"k156": "PWM Setting",
	"k157": "Measured Current (kA)",
	"k158": "Sample Value",
	"k159": "Primary Fine-Adjustment Coefficient",
	"k160": "Secondary Fine-Adjustment Coefficient",
	"k161": "Secondary Fine-Adjustment Coefficient",
	"k162": "Primary Calibration Value",
	"k163": "Secondary Calibration Value",
	"k164": "Electrode Force",
	"k165": "Electrode Primary Current",
	"k166": "Electrode Secondary Current",
	"k167": "Electrode 1 Counter",
	"k168": "Electrode 2 Counter",
	"k169": "Electrode 1 Tip Dressing",
	"k170": "Electrode 2 Tip Dressing",
	"k171": "Workpiece Information",
	"k172": "Production Batch No.",
	"k173": "Operator",
	"k174": "Start 1 Weld Schedule",
	"k175": "Start 2 Weld Schedule",
	"k176": "Search",
	"k177": "Weld Schedule Link Level Count",
	"k178": "Start Delay to Pre-Squeeze",
	"k179": "Function Selection",
	"k180": "Stepping Function",
	"k181": "Power Compensation (%)",
	"k182": "Reweld Function",
	"k183": "Check Function",
	"k184": "Maximum Reweld Count",
	"k185": "Start 2 Function",
	"k186": "Weld-Count-per-Workpiece Alarm",
	"k187": "Shift Production Count Alarm",
	"k188": "Start Timing Immediately After Alarm Reset",
	"k189": "Weld Gun Process-Weld-Spot Control",
	"k190": "Weld Gun Process-Weld-Spot Lower Limit",
	"k191": "Weld Gun Process-Weld-Spot Upper Limit",
	"k192": "Weld Gun Weld-Spot End Detection Time (s)",
	"k193": "Weld Count per Workpiece",
	"k194": "Shift Production Count",
	"k195": "Total Production Count",
	"k196": "Total Weld Count",
	"k197": "Current Value",
	"k198": "Reset to Zero",
	"k199": "Step Level",
	"k200": "Tip-Dressing Count",
	"k201": "Tip-Dressing Pre-Alarm",
	"k202": "Tip-Dressing Up Pressure",
	"k203": "Tip-Dressing Down Pressure",
	"k204": "Stepping Level 1",
	"k205": "Stepping Level 2",
	"k206": "Stepping Level 3",
	"k207": "Stepping Level 4",
	"k208": "Stepping Level 5",
	"k209": "Stepping Level 6",
	"k210": "Stepping Level 7",
	"k211": "Stepping Level 8",
	"k212": "Stepping Level 9",
	"k213": "Workpiece Name",
	"k214": "Error loading UIP curve data.",
	"k215": "Error retrieving settings from the offline library.",
	"k216": "Error retrieving settings from the machine.",
	"k217": "Weld Gun Shift Production Setpoint",
	"k218": "Setpoint",
	"k219": "Force Compensation (%)",
	"k220": "Select a date range.",
	"k221": "Date",
	"k222": "Time",
	"k223": "Alarm Description",
	"k224": "Record",
	"k225": "Created At",
	"k226": "Vehicle VIN",
	"k227": "Weld 1 (kA/ms)",
	"k228": "Weld 2 (kA/ms)",
	"k229": "Weld 3 (kA/ms)",
	"k230": "Active Weld Gun No.",
	"k231": "Energy (kJ)",
	"k232": "Output Pulse Width (%)",
	"k233": "Secondary Voltage (V)",
	"k234": "Secondary Resistance (µΩ)",
	"k235": "UIP Value",
	"k236": "All",
	"k237": "No Alarm",
	"k238": "With Alarm",
	"k239": "Before Change",
	"k240": "After Change",
	"k241": "Weld Spot ID",
	"k242": "Row No.",
	"k243": "Force (N)",
	"k244": "Sheet Thickness (mm)",
	"k245": "Vehicle Model",
	"k246": "Weld Spot Information",
	"k247": "Sheet 1 Material",
	"k248": "Sheet 1 Thickness (mm)",
	"k249": "Sheet 2 Material",
	"k250": "Sheet 2 Thickness (mm)",
	"k251": "Sheet 3 Material",
	"k252": "Sheet 3 Thickness (mm)",
	"k253": "Sheet 4 Material",
	"k254": "Sheet 4 Thickness (mm)",
	"k255": "Occurred",
	"k256": "Reset",
	"k257": "Description",
	"k258": "Vehicle Model Code",
	"k259": "Weld Spot Mapping No.",
	"k260": "Invalid query parameters.",
	"k261": "Current Machine",
	"k262": "Electrode 1",
	"k263": "Electrode 2",
	"k264": "Library -> Machine",
	"k265": "The offline library is not configured. Synchronization is not allowed.",
	"k266": "Export function error.",
	"k267": "Error reading weld schedule data.",
	"k268": "Primary Key",
	"k269": "Part Name",
	"k270": "Pre-Squeeze Time (ms)",
	"k271": "Follow-Up Time (ms)",
	"k272": "Pre-Weld Current (kA)",
	"k273": "Pre-Weld Time (ms)",
	"k274": "Cooling Time 0 (ms)",
	"k275": "Upslope Time (ms)",
	"k276": "Weld 1 Current (kA)",
	"k277": "Weld 1 Time (ms)",
	"k278": "Cooling Time 1 (ms)",
	"k279": "Weld 2 Current (kA)",
	"k280": "Weld 2 Time (ms)",
	"k281": "Cooling Time 2 (ms)",
	"k282": "Weld 3 Current (kA)",
	"k283": "Weld 3 Time (ms)",
	"k284": "Downslope Time (ms)",
	"k285": "Cooling Time 3 (ms)",
	"k286": "Post-Weld Current (kA)",
	"k287": "Post-Weld Time (ms)",
	"k288": "Post-Weld Hold Time (ms)",
	"k289": "Off Time (ms)",
	"k290": "Stepping Coefficient",
	"k291": "Repeat Count",
	"k292": "Current Weld Count",
	"k293": "Primary Capacitor Voltage",
	"k294": "Input Status (In00–In31)",
	"k295": "Output Status 0 (Out00–Out31)",
	"k296": "Current System Operating Mode",
	"k297": "Weld Gun 1 Weld Count per Workpiece",
	"k298": "Weld Gun 2 Weld Count per Workpiece",
	"k299": "Weld Gun 1 Shift Production Count",
	"k300": "Weld Gun 2 Shift Production Count",
	"k301": "Weld Gun 1 Total Production Count",
	"k302": "Weld Gun 2 Total Production Count",
	"k303": "Weld Gun 1 Total Weld Count",
	"k304": "Weld Gun 2 Total Weld Count",
	"k305": "Weld Gun 1 Stepping-Stage Counter",
	"k306": "Weld Gun 2 Stepping-Stage Counter",
	"k307": "Weld Gun 1 Tip-Dressing Counter",
	"k308": "Weld Gun 2 Tip-Dressing Counter",
	"k309": "Active Weld Schedule No. for Weld Gun 2",
	"k310": "Number of Historical Alarm Records",
	"k311": "Active Weld Gun No.",
	"k312": "Energy",
	"k313": "Load Capacity",
	"k314": "Secondary Voltage",
	"k315": "Secondary Resistance",
	"k316": "Alarm Flag",
	"k317": "Start 1 Weld Schedule Link Level Count",
	"k318": "Start-Delay-Past-Pre-Squeeze Function Selection",
	"k319": "Stepping Function Selection",
	"k320": "Weld Gun A Tip-Dressing Up Pressure",
	"k321": "Reweld Function Selection",
	"k322": "I/O Function Selection",
	"k323": "Weld Gun A Tip-Dressing Pressure",
	"k324": "Weld Gun Weld-Spot End Detection Time",
	"k325": "Number of Inverters",
	"k326": "Current-Feedback Detection",
	"k327": "Control-Function Priority Settings",
	"k328": "Stepping-Stage Count Setpoint",
	"k329": "Stepping-Stage Counter",
	"k330": "Tip-Dressing Count Setpoint",
	"k331": "Tip-Dressing Counter",
	"k332": "Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"k333": "Stepping Weld Count 1",
	"k334": "Power Compensation 1",
	"k335": "Force Compensation 1",
	"k336": "Stepping Weld Count 2",
	"k337": "Power Compensation 2",
	"k338": "Force Compensation 2",
	"k339": "Stepping Weld Count 3",
	"k340": "Power Compensation 3",
	"k341": "Force Compensation 3",
	"k342": "Stepping Weld Count 4",
	"k343": "Power Compensation 4",
	"k344": "Force Compensation 4",
	"k345": "Stepping Weld Count 5",
	"k346": "Power Compensation 5",
	"k347": "Force Compensation 5",
	"k348": "Stepping Weld Count 6",
	"k349": "Power Compensation 6",
	"k350": "Force Compensation 6",
	"k351": "Stepping Weld Count 7",
	"k352": "Power Compensation 7",
	"k353": "Force Compensation 7",
	"k354": "Stepping Weld Count 8",
	"k355": "Power Compensation 8",
	"k356": "Force Compensation 8",
	"k357": "Stepping Weld Count 9",
	"k358": "Tip-Dressing Up Pressure",
	"k359": "Tip-Dressing Down Pressure",
	"k360": "Weld Gun Configuration",
	"k361": "Weld Gun Configuration Mode",
	"k362": "Single Weld Gun",
	"k363": "Dual Weld Guns",
	"k364": "Multiple Weld Guns",
	"k365": "Weld Gun Large-Opening Mode",
	"k366": "Maintained",
	"k367": "Momentary",
	"k368": "Electrode-Arm State at Power-Off",
	"k369": "Small Opening",
	"k370": "Large Opening",
	"k371": "Valve Type for Weld Gun Large Opening",
	"k372": "Single-Solenoid",
	"k373": "Double-Solenoid",
	"k374": "Delayed Small-Opening Start",
	"k375": "Allow Welding with Insufficient Cooling Water",
	"k376": "Weld Gun 2 Water-Flow Monitoring Function",
	"k377": "User “{{.a}}” updated curve-acquisition settings for machine ID “{{.b}}”.",
	"k378": "User “{{.a}}” downloaded DIP weld schedule library “{{.c}}” to machine “{{.b}}”.",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "The weld spot mapping number already exists.",
	"k383": "Weld spot added successfully.",
	"k384": "Failed to add the weld spot.",
	"k385": "Weld spot updated successfully.",
	"k386": "Failed to update the weld spot.",
	"k387": "Failed to save extended weld spot information.",
	"k388": "Failed to query extended weld spot information.",
	"k389": "Download failed. Machine {{.a}} may be offline.",
	"k390": "The weld spot count is invalid or greater than 2000.",
	"k391": "UIR recording has not started.",
	"k392": "UIR recording has already started. Do not start it again.",
	"k393": "Start UIR Recording",
	"k394": "Stop UIR Recording",
	"k395": "Data query error.",
	"k396": "Selected Curve",
	"k397": "Generate Reference Curve",
	"k398": "-> Controller",
	"k399": "-> PC",
	"k400": "Curve Packet",
	"k401": "Loaded successfully.",
	"k402": "There is no alarm to reset.",
	"k403": "Error reading system parameters.",
	"k404": "The current-threshold mode in the import file does not match the target machine.",
	"w001": "Weld 1 Current Above Limit",
	"w002": "Weld 1 Current Below Limit",
	"w003": "Weld 2 Current Above Limit",
	"w004": "Weld 2 Current Below Limit",
	"w005": "Weld 3 Current Above Limit",
	"w006": "Weld 3 Current Below Limit",
	"w007": "IGBT Fault",
	"w008": "Emergency-Stop Fault",
	"w009": "Transformer 1 Overtemperature",
	"w010": "SCR Overtemperature",
	"w011": "Water Flow Switch Error",
	"w012": "Air-Pressure Switch Error",
	"w013": "Weld Enable Timeout",
	"w014": "Programmable Input 1 Timeout",
	"w015": "Programmable Input 2 Timeout",
	"w016": "Programmable Input 3 Timeout",
	"w017": "Memory Parameter Table Error",
	"w018": "Primary Capacitor Charging Timeout",
	"w019": "Foot Switch Closed at System Power-Up",
	"w020": "Primary Capacitor Voltage Too Low",
	"w021": "FRAM Data Write Error",
	"w022": "Pre-Squeeze Time Setting Error",
	"w023": "RS-485 Communication Fault",
	"w024": "Suspended-Gun Welding: Weld Gun 2 Water Flow Switch Alarm",
	"w025": "Safety Light Curtain Activated",
	"w026": "Transformer Type Setting Error",
	"w027": "Constant-Current Mode Setting Error",
	"w028": "Secondary-Current Range Setting Error",
	"w029": "Welding Inhibited Alarm",
	"w030": "Current Output Protection Active",
	"w031": "Transformer 2 Overtemperature",
	"w032": "Current-Feedback Error",
	"w033": "Weld Gun 1 Current Weld Count Reached the Per-Workpiece Setpoint",
	"w034": "Weld Gun 1 Actual Weld Count Above the Per-Workpiece Upper Limit",
	"w035": "Weld Gun 1 Actual Weld Count Below the Per-Workpiece Lower Limit",
	"w036": "Weld Gun 1 Shift Production Count Reached the Setpoint",
	"w037": "Weld Gun 1 Tip-Dressing Pre-Alarm",
	"w038": "Weld Gun 1 Tip-Dressing Alarm",
	"w039": "Weld Gun 1 Electrode Replacement Alarm",
	"w040": "Weld Gun 1 Electrode Replacement Pre-Alarm",
	"w041": "Reserved 01",
	"w042": "Weld Gun 2 Current Weld Count Reached the Per-Workpiece Setpoint",
	"w043": "Weld Gun 2 Actual Weld Count Above the Per-Workpiece Upper Limit",
	"w044": "Weld Gun 2 Actual Weld Count Below the Per-Workpiece Lower Limit",
	"w045": "Weld Gun 2 Shift Production Count Reached the Setpoint",
	"w046": "Weld Gun 2 Tip-Dressing Pre-Alarm",
	"w047": "Weld Gun 2 Tip-Dressing Alarm",
	"w048": "Weld Gun 2 Electrode Replacement Alarm",
	"w049": "Weld Gun 2 Electrode Replacement Pre-Alarm",
	"w050": "Reserved 49",
	"w051": "Reserved 50",
	"w052": "Reserved 51",
	"w053": "Reserved 52",
	"w054": "Reserved 53",
	"w055": "Reserved 54",
	"w056": "Reserved 55",
	"w057": "Reserved 56",
	"w058": "Reserved 57",
	"w059": "Reserved 58",
	"w060": "Reserved 59",
	"w061": "RTC Error",
	"w062": "SD Card Write Error",
	"w063": "Calibration Parameter Error",
	"w164": "Stepping Parameter Error",
	"w064": "Poor Contact in the Current-Feedback Cable",
	"w065": "Weld Resistance Too High",
	"w066": "Weld Resistance Too Low",
	"w067": "Secondary-Voltage Cable Fault",
	"w168": "UIP Too Low",
	"w069": "UIP Too High",
	"w068": "Adaptive Welding Fault",
	"w097": "Weld Expulsion Alarm",
	"w098": "Output Pulse Width Too High",
	"w099": "UIP Too Low",
	"w100": "UIP Too High",
	"z001": "{{.a}} (valid range: {{.b}}–{{.c}}{{.d}}); target setpoint: {{.e}}",
	"z002": "Not a floating-point number: {{.a}}",
	"z003": "Not a string: {{.a}}",
	"z004": "Expected length {{.a}}; actual length {{.b}}.",
	"z005": "The controller does not implement method {{.a}}.",
	"z006": "Offline",
	"z007": "Online",
	"z008": "Abnormal",
	"z009": "Deleted",
	"z010": "Invalid input for {{.a}}.",
	"z011": "Input validation error.",
	"z012": "Alarm Records",
	"z013": "Debug Program",
	"z014": "Database Management",
	"z015": "Change Records",
	"z016": "Production Management",
	"z017": "Weld Schedule Parameters",
	"z018": "Weld Records",
	"z019": "Real-Time Monitoring",
	"z020": "System Parameters",
	"z021": "Not Activated",
	"z022": "Active",
	"z023": "Locked",
	"z024": "Deleted",
	"z025": "Administrator",
	"z026": "Operator",
	"z027": "Viewer",
	"z028": "The weld schedule number is outside the range (0–959).",
	"z029": "The weld schedule number is outside the range (0–63).",
	"z030": "Controller 1 is not a valid integer.",
	"z031": "Controller 2 is not a valid integer.",
	"z032": "Weld schedule No. 1 is not a valid integer.",
	"z033": "Weld schedule No. 2 is not a valid integer.",
	"z034": "The same weld schedule cannot be compared with itself.",
	"z035": "Workpiece Name",
	"z036": "Production Batch No.",
	"z037": "Operator",
	"z038": "Error querying the offline weld schedule.",
	"z039": "Not an integer: {{.a}}",
	"z040": "Reconnecting...",
	"g001": "Weld Gun 3 Total Weld Count",
	"g002": "Weld Gun 4 Total Weld Count",
	"g003": "Weld Gun 5 Total Weld Count",
	"g004": "Weld Gun 3 Stepping-Stage Count Setpoint",
	"g005": "Weld Gun 3 Tip-Dressing Count Setpoint",
	"g006": "Weld Gun 3 Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"g007": "Weld Gun 3 Stepping-Stage Counter",
	"g008": "Weld Gun 3 Tip-Dressing Counter",
	"g009": "Weld Gun 4 Stepping-Stage Count Setpoint",
	"g010": "Weld Gun 4 Tip-Dressing Count Setpoint",
	"g011": "Weld Gun 4 Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"g012": "Weld Gun 4 Stepping-Stage Counter",
	"g013": "Weld Gun 4 Tip-Dressing Counter",
	"g014": "Weld Gun 5 Stepping-Stage Count Setpoint",
	"g015": "Weld Gun 5 Tip-Dressing Count Setpoint",
	"g016": "Weld Gun 5 Tip-Dressing Pre-Alarm Weld-Count Setpoint",
	"g017": "Weld Gun 5 Stepping-Stage Counter",
	"g018": "Weld Gun 5 Tip-Dressing Counter",
	"g019": "Weld Gun 3 Stepping Weld Count 1",
	"g020": "Weld Gun 3 Power Compensation 1",
	"g021": "Weld Gun 3 Force Compensation 1",
	"g022": "Weld Gun 3 Stepping Weld Count 2",
	"g023": "Weld Gun 3 Power Compensation 2",
	"g024": "Weld Gun 3 Force Compensation 2",
	"g025": "Weld Gun 3 Stepping Weld Count 3",
	"g026": "Weld Gun 3 Power Compensation 3",
	"g027": "Weld Gun 3 Force Compensation 3",
	"g028": "Weld Gun 3 Stepping Weld Count 4",
	"g029": "Weld Gun 3 Power Compensation 4",
	"g030": "Weld Gun 3 Force Compensation 4",
	"g031": "Weld Gun 3 Stepping Weld Count 5",
	"g032": "Weld Gun 3 Power Compensation 5",
	"g033": "Weld Gun 3 Force Compensation 5",
	"g034": "Weld Gun 3 Stepping Weld Count 6",
	"g035": "Weld Gun 3 Power Compensation 6",
	"g036": "Weld Gun 3 Force Compensation 6",
	"g037": "Weld Gun 3 Stepping Weld Count 7",
	"g038": "Weld Gun 3 Power Compensation 7",
	"g039": "Weld Gun 3 Force Compensation 7",
	"g040": "Weld Gun 3 Stepping Weld Count 8",
	"g041": "Weld Gun 3 Power Compensation 8",
	"g042": "Weld Gun 3 Force Compensation 8",
	"g043": "Weld Gun 3 Stepping Weld Count 9",
	"g044": "Weld Gun 3 Power Compensation 9",
	"g045": "Weld Gun 3 Force Compensation 9",
	"g046": "Weld Gun 4 Stepping Weld Count 1",
	"g047": "Weld Gun 4 Power Compensation 1",
	"g048": "Weld Gun 4 Force Compensation 1",
	"g049": "Weld Gun 4 Stepping Weld Count 2",
	"g050": "Weld Gun 4 Power Compensation 2",
	"g051": "Weld Gun 4 Force Compensation 2",
	"g052": "Weld Gun 4 Stepping Weld Count 3",
	"g053": "Weld Gun 4 Power Compensation 3",
	"g054": "Weld Gun 4 Force Compensation 3",
	"g055": "Weld Gun 4 Stepping Weld Count 4",
	"g056": "Weld Gun 4 Power Compensation 4",
	"g057": "Weld Gun 4 Force Compensation 4",
	"g058": "Weld Gun 4 Stepping Weld Count 5",
	"g059": "Weld Gun 4 Power Compensation 5",
	"g060": "Weld Gun 4 Force Compensation 5",
	"g061": "Weld Gun 4 Stepping Weld Count 6",
	"g062": "Weld Gun 4 Power Compensation 6",
	"g063": "Weld Gun 4 Force Compensation 6",
	"g064": "Weld Gun 4 Stepping Weld Count 7",
	"g065": "Weld Gun 4 Power Compensation 7",
	"g066": "Weld Gun 4 Force Compensation 7",
	"g067": "Weld Gun 4 Stepping Weld Count 8",
	"g068": "Weld Gun 4 Power Compensation 8",
	"g069": "Weld Gun 4 Force Compensation 8",
	"g070": "Weld Gun 4 Stepping Weld Count 9",
	"g071": "Weld Gun 4 Power Compensation 9",
	"g072": "Weld Gun 4 Force Compensation 9",
	"g073": "Weld Gun 5 Stepping Weld Count 1",
	"g074": "Weld Gun 5 Power Compensation 1",
	"g075": "Weld Gun 5 Force Compensation 1",
	"g076": "Weld Gun 5 Stepping Weld Count 2",
	"g077": "Weld Gun 5 Power Compensation 2",
	"g078": "Weld Gun 5 Force Compensation 2",
	"g079": "Weld Gun 5 Stepping Weld Count 3",
	"g080": "Weld Gun 5 Power Compensation 3",
	"g081": "Weld Gun 5 Force Compensation 3",
	"g082": "Weld Gun 5 Stepping Weld Count 4",
	"g083": "Weld Gun 5 Power Compensation 4",
	"g084": "Weld Gun 5 Force Compensation 4",
	"g085": "Weld Gun 5 Stepping Weld Count 5",
	"g086": "Weld Gun 5 Power Compensation 5",
	"g087": "Weld Gun 5 Force Compensation 5",
	"g088": "Weld Gun 5 Stepping Weld Count 6",
	"g089": "Weld Gun 5 Power Compensation 6",
	"g090": "Weld Gun 5 Force Compensation 6",
	"g091": "Weld Gun 5 Stepping Weld Count 7",
	"g092": "Weld Gun 5 Power Compensation 7",
	"g093": "Weld Gun 5 Force Compensation 7",
	"g094": "Weld Gun 5 Stepping Weld Count 8",
	"g095": "Weld Gun 5 Power Compensation 8",
	"g096": "Weld Gun 5 Force Compensation 8",
	"g097": "Weld Gun 5 Stepping Weld Count 9",
	"g098": "Weld Gun 5 Power Compensation 9",
	"g099": "Weld Gun 5 Force Compensation 9",
	"g100": "Weld Gun 3 Secondary Constant-Current Fine-Adjustment Parameter",
	"g101": "Weld Gun 4 Primary Constant-Current Fine-Adjustment Parameter",
	"g102": "Weld Gun 4 Secondary Constant-Current Fine-Adjustment Parameter",
	"g103": "Weld Gun 5 Primary Constant-Current Fine-Adjustment Parameter",
	"g104": "Weld Gun 5 Secondary Constant-Current Fine-Adjustment Parameter",
	"g105": "Weld Gun 3 Minimum Primary-Current PWM Output Setpoint",
	"g106": "Weld Gun 3 Level 1 Primary-Current PWM Output Setpoint",
	"g107": "Weld Gun 3 Level 2 Primary-Current PWM Output Setpoint",
	"g108": "Weld Gun 3 Level 3 Primary-Current PWM Output Setpoint",
	"g109": "Weld Gun 3 Level 4 Primary-Current PWM Output Setpoint",
	"g110": "Weld Gun 3 Level 5 Primary-Current PWM Output Setpoint",
	"g111": "Weld Gun 3 Level 6 Primary-Current PWM Output Setpoint",
	"g112": "Weld Gun 3 Maximum Primary-Current PWM Output Setpoint",
	"g113": "Weld Gun 3 Minimum Primary-Current Sample Value",
	"g114": "Weld Gun 3 Level 1 Primary-Current Sample Value",
	"g115": "Weld Gun 3 Level 2 Primary-Current Sample Value",
	"g116": "Weld Gun 3 Level 3 Primary-Current Sample Value",
	"g117": "Weld Gun 3 Level 4 Primary-Current Sample Value",
	"g118": "Weld Gun 3 Level 5 Primary-Current Sample Value",
	"g119": "Weld Gun 3 Level 6 Primary-Current Sample Value",
	"g120": "Weld Gun 3 Maximum Primary-Current Sample Value",
	"g121": "Weld Gun 3 Minimum Primary-Current Display Value",
	"g122": "Weld Gun 3 Level 1 Primary-Current Display Value",
	"g123": "Weld Gun 3 Level 2 Primary-Current Display Value",
	"g124": "Weld Gun 3 Level 3 Primary-Current Display Value",
	"g125": "Weld Gun 3 Level 4 Primary-Current Display Value",
	"g126": "Weld Gun 3 Level 5 Primary-Current Display Value",
	"g127": "Weld Gun 3 Level 6 Primary-Current Display Value",
	"g128": "Weld Gun 3 Maximum Primary-Current Display Value",
	"g129": "Weld Gun 3 Minimum Secondary-Current PWM Output Setpoint",
	"g130": "Weld Gun 3 Level 1 Secondary-Current PWM Output Setpoint",
	"g131": "Weld Gun 3 Level 2 Secondary-Current PWM Output Setpoint",
	"g132": "Weld Gun 3 Level 3 Secondary-Current PWM Output Setpoint",
	"g133": "Weld Gun 3 Level 4 Secondary-Current PWM Output Setpoint",
	"g134": "Weld Gun 3 Level 5 Secondary-Current PWM Output Setpoint",
	"g135": "Weld Gun 3 Level 6 Secondary-Current PWM Output Setpoint",
	"g136": "Weld Gun 3 Maximum Secondary-Current PWM Output Setpoint",
	"g137": "Weld Gun 3 Minimum Secondary-Current Sample Value",
	"g138": "Weld Gun 3 Level 1 Secondary-Current Sample Value",
	"g139": "Weld Gun 3 Level 2 Secondary-Current Sample Value",
	"g140": "Weld Gun 3 Level 3 Secondary-Current Sample Value",
	"g141": "Weld Gun 3 Level 4 Secondary-Current Sample Value",
	"g142": "Weld Gun 3 Level 5 Secondary-Current Sample Value",
	"g143": "Weld Gun 3 Level 6 Secondary-Current Sample Value",
	"g144": "Weld Gun 3 Maximum Secondary-Current Sample Value",
	"g145": "Weld Gun 3 Minimum Secondary-Current Display Value",
	"g146": "Weld Gun 3 Level 1 Secondary-Current Display Value",
	"g147": "Weld Gun 3 Level 2 Secondary-Current Display Value",
	"g148": "Weld Gun 3 Level 3 Secondary-Current Display Value",
	"g149": "Weld Gun 3 Level 4 Secondary-Current Display Value",
	"g150": "Weld Gun 3 Level 5 Secondary-Current Display Value",
	"g151": "Weld Gun 3 Level 6 Secondary-Current Display Value",
	"g152": "Weld Gun 3 Maximum Secondary-Current Display Value",
	"g153": "Weld Gun 4 Minimum Primary-Current PWM Output Setpoint",
	"g154": "Weld Gun 4 Level 1 Primary-Current PWM Output Setpoint",
	"g155": "Weld Gun 4 Level 2 Primary-Current PWM Output Setpoint",
	"g156": "Weld Gun 4 Level 3 Primary-Current PWM Output Setpoint",
	"g157": "Weld Gun 4 Level 4 Primary-Current PWM Output Setpoint",
	"g158": "Weld Gun 4 Level 5 Primary-Current PWM Output Setpoint",
	"g159": "Weld Gun 4 Level 6 Primary-Current PWM Output Setpoint",
	"g160": "Weld Gun 4 Maximum Primary-Current PWM Output Setpoint",
	"g161": "Weld Gun 4 Minimum Primary-Current Sample Value",
	"g162": "Weld Gun 4 Level 1 Primary-Current Sample Value",
	"g163": "Weld Gun 4 Level 2 Primary-Current Sample Value",
	"g164": "Weld Gun 4 Level 3 Primary-Current Sample Value",
	"g165": "Weld Gun 4 Level 4 Primary-Current Sample Value",
	"g166": "Weld Gun 4 Level 5 Primary-Current Sample Value",
	"g167": "Weld Gun 4 Level 6 Primary-Current Sample Value",
	"g168": "Weld Gun 4 Maximum Primary-Current Sample Value",
	"g169": "Weld Gun 4 Minimum Primary-Current Display Value",
	"g170": "Weld Gun 4 Level 1 Primary-Current Display Value",
	"g171": "Weld Gun 4 Level 2 Primary-Current Display Value",
	"g172": "Weld Gun 4 Level 3 Primary-Current Display Value",
	"g173": "Weld Gun 4 Level 4 Primary-Current Display Value",
	"g174": "Weld Gun 4 Level 5 Primary-Current Display Value",
	"g175": "Weld Gun 4 Level 6 Primary-Current Display Value",
	"g176": "Weld Gun 4 Maximum Primary-Current Display Value",
	"g177": "Weld Gun 4 Minimum Secondary-Current PWM Output Setpoint",
	"g178": "Weld Gun 4 Level 1 Secondary-Current PWM Output Setpoint",
	"g179": "Weld Gun 4 Level 2 Secondary-Current PWM Output Setpoint",
	"g180": "Weld Gun 4 Level 3 Secondary-Current PWM Output Setpoint",
	"g181": "Weld Gun 4 Level 4 Secondary-Current PWM Output Setpoint",
	"g182": "Weld Gun 4 Level 5 Secondary-Current PWM Output Setpoint",
	"g183": "Weld Gun 4 Level 6 Secondary-Current PWM Output Setpoint",
	"g184": "Weld Gun 4 Maximum Secondary-Current PWM Output Setpoint",
	"g185": "Weld Gun 4 Minimum Secondary-Current Sample Value",
	"g186": "Weld Gun 4 Level 1 Secondary-Current Sample Value",
	"g187": "Weld Gun 4 Level 2 Secondary-Current Sample Value",
	"g188": "Weld Gun 4 Level 3 Secondary-Current Sample Value",
	"g189": "Weld Gun 4 Level 4 Secondary-Current Sample Value",
	"g190": "Weld Gun 4 Level 5 Secondary-Current Sample Value",
	"g191": "Weld Gun 4 Level 6 Secondary-Current Sample Value",
	"g192": "Weld Gun 4 Maximum Secondary-Current Sample Value",
	"g193": "Weld Gun 4 Minimum Secondary-Current Display Value",
	"g194": "Weld Gun 4 Level 1 Secondary-Current Display Value",
	"g195": "Weld Gun 4 Level 2 Secondary-Current Display Value",
	"g196": "Weld Gun 4 Level 3 Secondary-Current Display Value",
	"g197": "Weld Gun 4 Level 4 Secondary-Current Display Value",
	"g198": "Weld Gun 4 Level 5 Secondary-Current Display Value",
	"g199": "Weld Gun 4 Level 6 Secondary-Current Display Value",
	"g200": "Weld Gun 4 Maximum Secondary-Current Display Value",
	"g201": "Weld Gun 5 Minimum Primary-Current PWM Output Setpoint",
	"g202": "Weld Gun 5 Level 1 Primary-Current PWM Output Setpoint",
	"g203": "Weld Gun 5 Level 2 Primary-Current PWM Output Setpoint",
	"g204": "Weld Gun 5 Level 3 Primary-Current PWM Output Setpoint",
	"g205": "Weld Gun 5 Level 4 Primary-Current PWM Output Setpoint",
	"g206": "Weld Gun 5 Level 5 Primary-Current PWM Output Setpoint",
	"g207": "Weld Gun 5 Level 6 Primary-Current PWM Output Setpoint",
	"g208": "Weld Gun 5 Maximum Primary-Current PWM Output Setpoint",
	"g209": "Weld Gun 5 Minimum Primary-Current Sample Value",
	"g210": "Weld Gun 5 Level 1 Primary-Current Sample Value",
	"g211": "Weld Gun 5 Level 2 Primary-Current Sample Value",
	"g212": "Weld Gun 5 Level 3 Primary-Current Sample Value",
	"g213": "Weld Gun 5 Level 4 Primary-Current Sample Value",
	"g214": "Weld Gun 5 Level 5 Primary-Current Sample Value",
	"g215": "Weld Gun 5 Level 6 Primary-Current Sample Value",
	"g216": "Weld Gun 5 Maximum Primary-Current Sample Value",
	"g217": "Weld Gun 5 Minimum Primary-Current Display Value",
	"g218": "Weld Gun 5 Level 1 Primary-Current Display Value",
	"g219": "Weld Gun 5 Level 2 Primary-Current Display Value",
	"g220": "Weld Gun 5 Level 3 Primary-Current Display Value",
	"g221": "Weld Gun 5 Level 4 Primary-Current Display Value",
	"g222": "Weld Gun 5 Level 5 Primary-Current Display Value",
	"g223": "Weld Gun 5 Level 6 Primary-Current Display Value",
	"g224": "Weld Gun 5 Maximum Primary-Current Display Value",
	"g225": "Weld Gun 5 Minimum Secondary-Current PWM Output Setpoint",
	"g226": "Weld Gun 5 Level 1 Secondary-Current PWM Output Setpoint",
	"g227": "Weld Gun 5 Level 2 Secondary-Current PWM Output Setpoint",
	"g228": "Weld Gun 5 Level 3 Secondary-Current PWM Output Setpoint",
	"g229": "Weld Gun 5 Level 4 Secondary-Current PWM Output Setpoint",
	"g230": "Weld Gun 5 Level 5 Secondary-Current PWM Output Setpoint",
	"g231": "Weld Gun 5 Level 6 Secondary-Current PWM Output Setpoint",
	"g232": "Weld Gun 5 Maximum Secondary-Current PWM Output Setpoint",
	"g233": "Weld Gun 5 Minimum Secondary-Current Sample Value",
	"g234": "Weld Gun 5 Level 1 Secondary-Current Sample Value",
	"g235": "Weld Gun 5 Level 2 Secondary-Current Sample Value",
	"g236": "Weld Gun 5 Level 3 Secondary-Current Sample Value",
	"g237": "Weld Gun 5 Level 4 Secondary-Current Sample Value",
	"g238": "Weld Gun 5 Level 5 Secondary-Current Sample Value",
	"g239": "Weld Gun 5 Level 6 Secondary-Current Sample Value",
	"g240": "Weld Gun 5 Maximum Secondary-Current Sample Value",
	"g241": "Weld Gun 5 Minimum Secondary-Current Display Value",
	"g242": "Weld Gun 5 Level 1 Secondary-Current Display Value",
	"g243": "Weld Gun 5 Level 2 Secondary-Current Display Value",
	"g244": "Weld Gun 5 Level 3 Secondary-Current Display Value",
	"g245": "Weld Gun 5 Level 4 Secondary-Current Display Value",
	"g246": "Weld Gun 5 Level 5 Secondary-Current Display Value",
	"g247": "Weld Gun 5 Level 6 Secondary-Current Display Value",
	"g248": "Weld Gun 5 Maximum Secondary-Current Display Value",
	"g249": "Weld Gun 3 Primary Constant-Current Fine-Adjustment Parameter",
	"g250": "Undefined type: {{.a}}",
	"g251": "Weld Gun 3 Electrode-Force Stage 1 Output Setpoint",
	"g252": "Weld Gun 3 Electrode-Force Stage 2 Output Setpoint",
	"g253": "Weld Gun 3 Electrode-Force Stage 1 Measured Display Value",
	"g254": "Weld Gun 3 Electrode-Force Stage 2 Measured Display Value",
	"g255": "Weld Gun 4 Electrode-Force Stage 1 Output Setpoint",
	"g256": "Weld Gun 4 Electrode-Force Stage 2 Output Setpoint",
	"g257": "Weld Gun 4 Electrode-Force Stage 1 Measured Display Value",
	"g258": "Weld Gun 4 Electrode-Force Stage 2 Measured Display Value",
	"g259": "Weld Gun 5 Electrode-Force Stage 1 Output Setpoint",
	"g260": "Weld Gun 5 Electrode-Force Stage 2 Output Setpoint",
	"g261": "Weld Gun 5 Electrode-Force Stage 1 Measured Display Value",
	"g262": "Weld Gun 5 Electrode-Force Stage 2 Measured Display Value",
	"d001": "Refresh Count",
	"d002": "The weld spot mapping number is required and must be an integer.",
	"d003": "The weld schedule number is required and must be an integer.",
	"d004": "Force is required and must be an integer.",
	"d005": "Sheet thickness is required and must be a decimal number (valid range: 0–99999.99).",
	"d006": "X is required and must be a decimal number (valid range: 0–999999.9999999999).",
	"d007": "Y is required and must be a decimal number (valid range: 0–999999.9999999999).",
	"d008": "Z is required and must be a decimal number (valid range: 0–999999.9999999999).",
	"d009": "Sheet 1 thickness must be a decimal number (valid range: 0–99999.99).",
	"d010": "Sheet 2 thickness must be a decimal number (valid range: 0–99999.99).",
	"d011": "Sheet 3 thickness must be a decimal number (valid range: 0–99999.99).",
	"d012": "Sheet 4 thickness must be a decimal number (valid range: 0–99999.99).",
	"d013": "Cleared data cannot be recovered. Clear the data?",
	"d014": "System Parameter Records",
	"d015": "Weld Spot Management Records",
	"d016": "Operation Type",
	"d017": "Add",
	"d018": "Modify",
	"d019": "Parameter Comparison",
	"d020": "The operator does not exist. The query cannot be performed.",
	"d021": "The setpoint is missing or invalid.",
	"d022": "Import Count",
	"d023": "Calculating Count",
	"d024": "Validation Count",
	"d025": "Clear Count",
	"d026": "Download Count",
	"d027": "Data cleared successfully.",
	"d028": "Failed to clear data.",
	"d029": "Refresh Weld Spots",
	"d030": "Refresh weld spots for the selected machines?",
	"d031": "An error occurred while refreshing weld spots. The operation cannot be performed.",
	"d032": "Weld spot refresh canceled.",
	"d033": "The machine is offline. This operation cannot be performed.",
	"d034": "Weld spots refreshed successfully.",
	"d035": "Weld Spot Refresh Progress Overview",
	"d036": "Weld Spot Refresh Details",
	"d037": "Weld Spot Refresh Progress",
	"d038": "Refreshing Weld Spots",
	"d039": "Weld spot refresh failed.",
	"d040": "Canceling weld spot refresh will stop all subsequent operations. Continue?",
	"d041": "The weld spot task has been retried.",
	"e001": "Expulsion Statistics",
	"e002": "View Expulsion Statistics",
	"e003": "Manage Expulsion Statistics",
	"e004": "Query Dimension",
	"e005": "Weld Spot",
	"e006": "Invalid query dimension.",
	"e007": "Expulsion Count",
	"e008": "Weld Spot Count",
	"e009": "Total Count",
	"e010": "Expulsion-Free Rate",
	"e011": "Data View",
	"e012": "Error retrieving vehicle-model data.",
	"e013": "Weld spot filter; separate multiple values with commas.",
	"e014": "Weld schedule filter; separate multiple values with commas.",
	"e015": "Click to Copy",
	"e016": "No.",
	"e017": "<p>1. Select a dimension for the expulsion-rate query, then click “Search.”</p><p>2. After selecting an area, machine, vehicle model, weld spot, or weld schedule, you can further select an item from the list on the left.</p><p>3. After selecting weld spot or weld schedule, enter values to filter in the search field; separate multiple values with commas.</p>",
	"e018": "Factory",
	"e019": "Expulsion Records",
	"e020": "Clear Query",
	"e021": "Export completed.",
	"e022": "Start Exporting Weld Schedules",
	"e023": "Exporting Weld Schedules",
	"e024": "Start Synchronization",
	"e025": "Synchronizing",
	"e026": "Start Importing Weld Schedules",
	"e027": "Importing Weld Schedules",
	"e028": "Error writing weld schedules.",
	"e029": "Starting Weld Schedule No.",
	"e030": "Ending Weld Schedule No.",
	"e031": "Convert Vehicle VIN to Sequence Number",
	"e032": "Enter the vehicle VIN range.",
	"e033": "The vehicle VIN must be an integer.",
	"e034": "The UIP value must be an integer greater than 0.",
	"e035": "<p>Negative filtering of alarm descriptions is supported. For example, “!Weld 1 Current Above Limit” excludes records containing “Weld 1 Current Above Limit.”</p>",
	"e036": "Includes Curve",
	"e037": "Recording",
	"e038": "Recording Not Started",
	"e039": "Pre-Weld (kA/ms)",
	"e040": "Post-Weld (kA/ms)",
	"e041": "Curve Data",
	"e042": "Browse Historical Curves",
	"e043": "The uploaded file contains no weld records.",
	"e044": "Records browsed successfully.",
	"e045": "Pre-Weld Current Setpoint",
	"e046": "Weld 1 Current Setpoint",
	"e047": "Weld 2 Current Setpoint",
	"e048": "Weld 3 Current Setpoint",
	"e049": "Post-Weld Current Setpoint",
	"e050": "Weld 1 Minimum Current Setpoint",
	"e051": "Weld 1 Maximum Current Setpoint",
	"e052": "Weld 2 Minimum Current Setpoint",
	"e053": "Weld 2 Maximum Current Setpoint",
	"e054": "Weld 3 Minimum Current Setpoint",
	"e055": "Weld 3 Maximum Current Setpoint",
	"e056": "Weld 2 Pulse-Count Setpoint",
	"e057": "Export Curves",
	"e058": "Export Options",
	"e059": "Select the file to export from the weld records.",
	"e060": "The current record does not contain a curve.",
	"e061": "Invalid submitted parameters.",
	"e062": "Service error.",
	"e063": "Error writing communication parameters.",
	"e064": "Batch Delete",
	"e065": "Select the weld spots to delete.",
	"e066": "Save as Image",
	"a001": "Manual",
	"a002": "Standalone",
	"a003": "Cycle Time",
	"a004": "seconds",
	"a005": "Pre-Squeeze",
	"a006": "Pressurization",
	"a007": "Air Blow",
	"a008": "Welding",
	"a009": "Active Weld Schedule No.",
	"a010": "Weld Schedule Setpoint",
	"a011": "Weld Schedule Description",
	"a012": "Total Workpiece Count",
	"a013": "Production Count",
	"a014": "Weld Current",
	"a015": "Electrode Life",
	"a016": "Weld Force",
	"a017": "Fusion Threshold",
	"a018": "Remaining Weld Count",
	"a019": "Maximum Value",
	"a020": "Minimum Value",
	"a021": "Pre-Weld Displacement",
	"a022": "Post-Weld Displacement",
	"a023": "Emergency Stop (NC)",
	"a024": "Air Pressure Alarm (NC)",
	"a025": "Chiller Alarm",
	"a026": "Water Flow Alarm (NC)",
	"a027": "Door Interlock Switch",
	"a028": "Water Temperature Alarm",
	"a029": "Safety Light Curtain",
	"a030": "Remote Emergency Stop",
	"a031": "HV Contactor Feedback",
	"a032": "Single Workpiece Weld Count Reset",
	"a033": "Safety Valve Feedback",
	"a034": "Skip-Weld Reset",
	"a035": "Manual/Auto",
	"a036": "Standalone/Online",
	"a037": "Check/Power On",
	"a038": "Two-Hand Start 2",
	"a039": "Two-Hand Start 1",
	"a040": "Foot Switch Start",
	"a041": "Single-Hand Start",
	"a042": "Moving Electrode 2 Home Position",
	"a043": "Moving Electrode 1 Home Position",
	"a044": "Moving Electrode 2 Advanced Position",
	"a045": "Moving Electrode 1 Advanced Position",
	"a046": "Fixed Electrode 2 Locating Pin Extended",
	"a047": "Fixed Electrode 1 Locating Pin Extended",
	"a048": "Fixed Electrode 2 Locating Pin Retracted",
	"a049": "Fixed Electrode 1 Locating Pin Retracted",
	"a050": "Conveyor 1 Feed Complete",
	"a051": "Conveyor 1 General Alarm",
	"a052": "Conveyor 1 Transfer Bar Home Position",
	"a053": "Conveyor 1 Material Shortage Alarm",
	"a054": "Conveyor 1 Transfer Bar Advanced Position",
	"a055": "Conveyor 1 Lift Cylinder Home Position Alarm",
	"a056": "Conveyor 1 Lift Cylinder Advanced Position Alarm",
	"a057": "Conveyor 2 Feed Complete",
	"a058": "Conveyor 2 General Alarm",
	"a059": "Conveyor 2 Transfer Bar Home Position",
	"a060": "Conveyor 2 Material Shortage Alarm",
	"a061": "Conveyor 2 Transfer Bar Advanced Position",
	"a062": "Conveyor 2 Lift Cylinder Home Position Alarm",
	"a063": "Conveyor 2 Lift Cylinder Advanced Position Alarm",
	"a064": "Conveyor 3 Feed Complete",
	"a065": "Conveyor 3 General Alarm",
	"a066": "Conveyor 3 Transfer Bar Home Position",
	"a067": "Conveyor 3 Material Shortage Alarm",
	"a068": "Conveyor 3 Transfer Bar Advanced Position",
	"a069": "Conveyor 3 Lift Cylinder Home Position Alarm",
	"a070": "Conveyor 3 Lift Cylinder Advanced Position Alarm",
	"a071": "Conveyor 4 Feed Complete",
	"a072": "Conveyor 4 General Alarm",
	"a073": "Conveyor 4 Transfer Bar Home Position",
	"a074": "Conveyor 4 Material Shortage Alarm",
	"a075": "Conveyor 4 Transfer Bar Advanced Position",
	"a076": "Conveyor 4 Lift Cylinder Home Position Alarm",
	"a077": "Conveyor 4 Lift Cylinder Advanced Position Alarm",
	"a078": "Main Water Outlet Valve",
	"a079": "Signal Tower Buzzer",
	"a080": "Main Water Inlet Valve",
	"a081": "Signal Tower (Green)",
	"a082": "Moving Electrode 1 Force Booster Valve",
	"a083": "Signal Tower (Yellow)",
	"a084": "Moving Electrode 2 Force Booster Valve",
	"a085": "Signal Tower (Red)",
	"a086": "Fixed Electrode 1 Air Blow Valve",
	"a087": "Moving Electrode 1 Pressurization Valve",
	"a088": "Moving Electrode 1 Auxiliary Stroke Valve (Single Solenoid)",
	"a089": "Moving Electrode 1 Pre-Squeeze Valve (Single Solenoid)",
	"a090": "Moving Electrode 1 Auxiliary Stroke Valve Small Open (Dual Solenoid)",
	"a091": "Moving Electrode 1 Up (Dual Solenoid)",
	"a092": "Moving Electrode 1 Auxiliary Stroke Valve Large Open (Dual Solenoid)",
	"a093": "Moving Electrode 1 Down (Dual Solenoid)",
	"a094": "Fixed Electrode 2 Air Blow Valve",
	"a095": "Moving Electrode 2 Pressurization Valve",
	"a096": "Moving Electrode 2 Auxiliary Stroke Valve (Single Solenoid)",
	"a097": "Moving Electrode 2 Pre-Squeeze Valve (Single Solenoid)",
	"a098": "Moving Electrode 2 Auxiliary Stroke Valve Small Open (Dual Solenoid)",
	"a099": "Moving Electrode 2 Up (Dual Solenoid)",
	"a100": "Moving Electrode 2 Auxiliary Stroke Valve Large Open (Dual Solenoid)",
	"a101": "Moving Electrode 2 Down (Dual Solenoid)",
	"a102": "Conveyor 1 Return to Home",
	"a103": "Conveyor 1 Start",
	"a104": "Conveyor 2 Return to Home",
	"a105": "Conveyor 2 Start",
	"a106": "Conveyor 3 Return to Home",
	"a107": "Conveyor 3 Start",
	"a108": "Conveyor 4 Return to Home",
	"a109": "Conveyor 4 Start",
	"a110": "Fixed Electrode 1 Locating Pin Valve",
	"a111": "Fixed Electrode 2 Locating Pin Valve",
	"a112": "Chiller Switch",
	"a113": "Discharge Request",
	"a114": "Safety Guard",
	"a115": "Hardware Configuration",
	"a116": "Function Configuration",
	"a117": "Communication Configuration",
	"a118": "Calibration",
	"a119": "System Information",
	"a120": "Cabinet Door",
	"a121": "Air Supply Pressure",
	"a122": "Light Curtain",
	"a123": "Water Flow",
	"a124": "Buzzer",
	"a125": "Signal Tower",
	"a126": "Button/Switch",
	"a127": "Foot Switch",
	"a128": "Single Hand",
	"a129": "Two Hands",
	"a130": "Air Circuit",
	"a131": "Air Inlet Solenoid Valve",
	"a132": "Proportional Valve",
	"a133": "Pre-Pressure Valve",
	"a134": "Pressurization Solenoid Valve",
	"a135": "Air Blow Solenoid Valve",
	"a136": "Stroke Solenoid Valve",
	"a137": "Force Booster Solenoid Valve",
	"a138": "Shared Pre-Pressure + Pressurization Proportional Valve",
	"a139": "Independent Pre-Pressure + Pressurization Proportional Valve",
	"a140": "Manual Pre-Pressure Adjustment + Pressurization Proportional Valve",
	"a141": "No Modification",
	"a142": "Water Circuit",
	"a143": "Water Inlet Solenoid Valve",
	"a144": "Water Outlet Solenoid Valve",
	"a145": "Chiller",
	"a146": "Position Switch",
	"a147": "Moving Electrode Home Position",
	"a148": "Moving Electrode Advanced Position",
	"a149": "Locating Pin Extended",
	"a150": "Locating Pin Retracted",
	"a151": "Sensor",
	"a152": "Encoder Displacement",
	"a153": "Laser Displacement",
	"a154": "Water Temperature Detection",
	"a155": "Electrode Force",
	"a156": "No Assembly",
	"a157": "Air Pressure Sensor",
	"a158": "Load Cell",
	"a159": "No modifications made to configuration, cannot save.",
	"a160": "Conveyor",
	"a161": "Conveyor 1",
	"a162": "Conveyor 2",
	"a163": "Conveyed Material",
	"a164": "Feeding Method",
	"a165": "Conveying Direction",
	"a166": "Controller",
	"a167": "Type",
	"a168": "Interface",
	"a169": "Auto Return to Home on Reaching Position",
	"a170": "Position Hold",
	"a171": "Send to Fixed Electrode",
	"a172": "Send to Moving Electrode",
	"a173": "Nut",
	"a174": "Bolt",
	"a175": "Communication",
	"a176": "Communication (Real-Time Data) + I/O (Start/Stop, Reset, Key Status, Weld Schedule No., etc.)",
	"a177": "Locating Pin",
	"a178": "Moving Electrode",
	"a179": "Solenoid Valve",
	"a180": "Baud Rate",
	"a181": "HRC803 Address",
	"a182": "Subnet Mask",
	"a183": "Gateway",
	"a184": "Signal Interaction",
	"a185": "Standalone Mode Start Method",
	"a186": "Start Signal Revocable",
	"a187": "Weld Cycle End Signal Type",
	"a188": "Auto-Reset When Per-Workpiece Weld Count Reaches Limit",
	"a189": "Pressure",
	"a190": "Pressure Unit",
	"a191": "Force Booster Enable Threshold",
	"a192": "Time",
	"a193": "Continuous Mode Interval Time",
	"a194": "Chiller Auto-Stop Time",
	"a195": "Two-Hand Start",
	"a196": "Build Time",
	"a197": "UI Version",
	"a198": "All",
	"a199": "Tip Dressing or Check",
	"a200": "Device: {{.a}} Connected Successfully",
	"a201": "Device: {{.a}} Disconnected Successfully",
	"a202": "Connect/Disconnect",
	"a203": "Welding Data Push Enable"
}